// 德语
import deLocale from 'element-ui/lib/locale/lang/de'


const de = {
  // ============== 登陆页 start=============
  "登录": "Anmelden",
  "退出": "Abmelden",
  "账号": "Konto",
  "密码": "Passwort",
  "验证码": "Verifizierungscode",
  "请输入账号": "Bitte geben Sie Ihr Konto ein",
  "请输入密码": "Bitte geben Sie Ihr Passwort ein",
  "请输入验证码": "Bitte geben Sie den Verifizierungscode ein",
  "验证码不正确": "Falscher Verifizierungscode",
  "没有账号": "Kein Konto",
  "请": "Bitte",
  "点击注册": "Klicken Sie hier, um sich zu registrieren",
  // ============== 登陆页 end  =============
  // =========== 首页 start==================
  "门店总量": "Gesamtzahl der Geschäfte",
  "用户总量": "Gesamtnutzerzahl",
  "营业总量": "Gesamtumsatz des Unternehmens",
  "订单总量": "Gesamtauftragsvolumen",
  "商品总量": "Gesamtbestandsmenge",
  "销售总额": "Gesamtumsatz",
  "元": "€",
  "预计收入": "Geschütztes Einkommen",
  "今日概况": "Zusammenfassung des heutigen Tages",
  "销售额": "Umsatzvolumen",
  "支付订单数": "Bezahlte Bestellungen",
  "昨日": "Gestern",
  "新增用户数": "Neue Benutzer",
  "新增商户": "Neue Händler",
  "下单用户数": "Benutzer, die Bestellungen aufgeben",
  "待办事项": "Ausstehende Aufgaben",
  "请尽快处理，以免影响营业": "Bitte umgehend bearbeiten, um Auswirkungen auf das Geschäft zu vermeiden",
  "待处理订单": "Bearbeitung ausstehender Bestellungen",
  "库存告急": "Lagerbestand in Notlage",
  "销量": "Verkaufsvolumen",
  "暂无上榜记录": "Keine Aufzeichnungen in der Rangliste vorhanden",
  "成交额": "Transaktionsvolumen",
  "成交量": "Transaktionsaufträge",
  "退单额": "Gesamtbetrag der Rückerstattungen",
  "退单量": "Rückgabebestellungen",
  // =========== 首页 end==================
  // =========== 建店必做 start=============
  "基本资料": "Grundinformationen",
  "编辑门店": "Geschäft bearbeiten",
  "官方网站": "Offizielle Webseite",
  "门店服务": "Geschäftsleistungen",
  "服务与营业时间": "Dienstleistungen und Öffnungszeiten",
  "桌码管理": "Tischcodeverwaltung",
  "收银台": "Kasse",
  "后厨": "Küche",
  "商品": "Waren",
  "添加商品": "Waren hinzufügen",
  "网站": "Webseite",
  "网站编辑": "Webseitenbearbeitung",
  "上一步": "Vorheriger Schritt",
  "保存": "Speichern",
  "下一步": "Nächster Schritt",
  "提交失败": "Einreichung fehlgeschlagen",
  "获取当前进度信息失败": "Fehler beim Abrufen der aktuellen Fortschrittsinformationen",
  "请输入门店名称": "Bitte geben Sie den Geschäftsname ein",
  "登录密码": "Anmeldedetails",
  "请输入登录密码": "Bitte geben Sie das Anmeldekennwort ein",
  "确认密码": "Passwort bestätigen",
  "请输入确认密码": "Bitte bestätigen Sie das Passwort",
  "联系人": "Kontakt",
  "请输入联系人": "Bitte geben Sie den Ansprechpartner ein",
  "请输入联系电话": "Bitte geben Sie die Kontakttelefonnummer ein",
  "店铺类型": "Geschäftstyp",
  "分店": "Filiale",
  "直营": "Direktvertrieb",
  "商品分类": "Warenkategorisierung",
  "同步主店": "Synchronisierung mit Hauptgeschäft",
  "分店创建": "Filialerstellung",
  "温馨提示：选择后，请勿随意修改，以免造成门店商品数据错乱": "Freundliche Erinnerung: Bitte nach Auswahl nicht willkürlich ändern, um Verwirrung der Geschäftsdaten zu vermeiden",
  "绑定用户": "Benutzer binden",
  "选择用户": "Benutzer auswählen",
  "用户昵称": "Benutzername",
  "门店logo": "Geschäftslogo",
  "选择图片": "Bild auswählen",
  "地址": "Adresse",
  "请输入地址": "Bitte geben Sie die Adresse ein",
  "门店坐标": "Geschäftsstandortkoordinaten",
  "商家介绍": "Geschäftbeschreibung",
  "状态": "Status",
  "开启": "öffnen",
  "禁止": "schließen",
  "营业状态": "Betriebsstatus",
  "营业中": "Geöffnet",
  "停止营业": "Geschlossen",
  "上传图片": "Bild hochladen",
  "获取当前门店失败，请刷新界面重试": "Aktuellen Geschäftsstandort nicht abrufbar, bitte Seite aktualisieren und erneut versuchen",
  "商城设置": "Einstellungen des Shops",
  "商城名称": "Shop-Name",
  "商城名称不能为空": "Shop-Name darf nicht leer sein",
  "访问网址后缀": "Besuchs-URL-Suffix",
  "访问网址": "Besuchs-URL",
  "手机网站": "Mobile Webseite",
  "默认": "Standard",
  "自定义": "Anpassen",
  "Pad点餐网站": "Pad-Bestellwebseite",
  "收银台网站": "Kassenwebseite",
  "后厨网站": "Küchenwebseite",
  "会员设置": "Mitgliedereinstellungen",
  "请选择默认头像": "Bitte wählen Sie ein Standardprofilbild",
  "门店二维码": "Geschäfts-QR-Code.",
  "下载": "Herunterladen",
  "营业时间": "öffnungszeiten",
  "店内营业时间": "öffnungszeiten im Laden",
  "请选择店内营业时间": "Bitte wählen Sie die Öffnungszeiten im Laden",
  "开始时间": "Startzeit",
  "结束时间": "Endzeit",
  "至": "Bis",
  "选择时间范围": "Zeitbereich auswählen",
  "自提营业时间": "Abholzeiten",
  "请选择自提营业时间": "Bitte wählen Sie die Abholzeiten",
  "外卖营业时间": "Lieferzeiten",
  "请选择外卖营业时间": "Bitte wählen Sie die Lieferzeiten",
  "外卖配送": "Lieferung",
  "注": "Hinweis",
  "外卖配送方式至少选择一个": "Mindestens eine Liefermethode für Takeaways muss ausgewählt werden",
  "店内配置": "Ladenkonfiguration",
  "店内用餐方式至少选择一个": "Es muss mindestens eine Art des Speisens im Laden ausgewählt werden",
  "堂食服务": "Servieren im Laden",
  "店内堂食结算模式": "Abrechnungsmodus für das Servieren im Laden",
  "先结账后用餐": "Zuerst bezahlen, dann speisen",
  "先用餐后结账": "Zuerst speisen, dann bezahlen",
  "收银台桌台清台设置": "Einstellungen zur Tischabrechnung an der Kasse",
  "定时清台": "Zeitgesteuertes Räumen der Tische",
  "立即清台": "Unverzügliches Räumen der Tische",
  "开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效": "Nach Aktivierung des zeitgesteuerten Tischräumens wird das System die Tische der Bestellungen an der Kasse nach Ablauf der Zeit automatisch räumen. Diese Funktion ist nur im Vorauszahlungsmodus vor dem Essen aktiv",
  "桌台订单清台设置": "Einstellungen zum Räumen von Tischbestellungen",
  "分钟后自动清理桌台（扫桌码点餐和收银桌台点餐定时清台时间）": "Tische nach Minuten automatisch räumen (Zeit für das Bestellen über Tischcodes und das zeitgesteuerte Räumen der Tische an der Kasse)",
  "店内堂食服务费": "Gebühr für das Speisen im Laden",
  "按就餐人数收取": "Abrechnung nach Anzahl der Personen",
  "按每桌台收取": "Pro Tisch abrechnen",
  "请输入服务费": "Bitte geben Sie die Servicegebühr ein",
  "位": "Platz",
  "桌": "Tisch",
  "店内包装费类型": "Art der Verpackungsgebühr im Laden",
  "按商品收费": "Abrechnung nach Waren",
  "按单收费": "Einzelabrechnung",
  "包装费": "Verpackungsgebühr",
  "请输入包装费": "Bitte geben Sie die Verpackungsgebühr ein",
  "外卖服务": "Lieferservice",
  "外卖包装费类型": "Art der Verpackungsgebühr für Lieferungen",
  "外卖配送范围": "Lieferbereich",
  "请输入外卖配送范围": "Bitte geben Sie den Lieferbereich ein",
  "外卖配送费": "Liefergebühr",
  "请输入外卖配送费": "Bitte geben Sie die Liefergebühr ein",
  "最低消费": "Mindestbestellwert",
  "请输入最低消费": "Bitte geben Sie den Mindestbestellwert ein",
  "添加类型": "Typ hinzufügen",
  "类型名称": "Typname",
  "人数区间": "Personenbereich",
  "添加时间": "Hinzufügezeit",
  "操作": "Aktion",
  "删除": "Löschen",
  "桌位管理": "Verwaltung der Tische",
  "最少人数": "Minimale Personenanzahl",
  "最多人数": "Maximale Personenanzahl",
  "取 消": "Abbrechen",
  "确 定": "Bestätigen",
  "请输入类型名称": "Bitte geben Sie den Typnamen ein",
  "排序不能为空": "Sortierung darf nicht leer sein",
  "排序必须为数字": "Sortierung muss eine Zahl sein",
  "添加成功": "Erfolgreich hinzugefügt",
  "修改类型": "Typ bearbeiten",
  "修改成功": "Erfolgreich geändert",
  "添加区域": "Bereich hinzufügen",
  "区域名称": "Bereichsname",
  "修改区域": "Bereich bearbeiten",
  "请输入区域名称": "Bitte geben Sie den Bereichsnamen ein",
  "分类名称": "Kategoriename",
  "编号": "Nummer",
  "选择区域": "Bereich auswählen",
  "请选择": "Bitte wählen",
  "选择类型": "Typ auswählen",
  "查询": "Suchen",
  "桌号id": "Tischnummer-ID",
  "所属区域": "Zugehöriger Bereich",
  "桌位类型": "Tischart",
  "桌位编码": "Tischcode",
  "人": "Personen",
  "二维码": "QR-Code",
  "桌位编号": "Tischnummer",
  "请输入桌位编号": "Bitte geben Sie die Tischnummer ein",
  "请选择类型名称": "Bitte wählen Sie den Typnamen",
  "请选择所属区域": "Bitte wählen Sie den zugehörigen Bereich",
  "添加桌位": "Tisch hinzufügen",
  "关键词": "Stichwort",
  "添加收银员": "Kassierer hinzufügen",
  "姓名": "Name",
  "登录账号": "Anmeldekonto",
  "联系方式": "Kontaktmethode",
  "收银员管理": "Kassierer-Verwaltung",
  "编辑": "Bearbeiten",
  "手机号": "Handynummer",
  "请输入登录账号": "Bitte geben Sie das Anmeldekonto ein",
  "长度在6到16个字符": "Länge zwischen 6 und 16 Zeichen",
  "两次输入密码不一致！": "Die beiden eingegebenen Passwörter stimmen nicht überein!",
  "禁用": "Deaktivieren",
  "删除后不可恢复，确认删除该记录吗?": "Nach dem Löschen kann dies nicht wiederhergestellt werden. Möchten Sie diesen Datensatz wirklich löschen?",
  "提示": "Hinweis",
  "后厨人员管理": "Küchenpersonal-Verwaltung",
  "添加后厨人员": "Küchenpersonal hinzufügen",
  "添加后厨账号": "Küchenkonto hinzufügen",
  "普通分类": "Allgemeine Klassifizierung",
  "添加分类": "Kategorie hinzufügen",
  "图片": "Bild",
  "分类排序": "Kategorienreihenfolge",
  "税率设置": "Steuersatz-Einstellung",
  "添加税率": "Steuersatz hinzufügen",
  "税率分类名称": "Steuersatz Kategoriename",
  "税率": "Steuersatz",
  "适用于菜品分类": "Anwendbar auf Gerichtsklassifizierung",
  "未找到相应数据": "Keine entsprechenden Daten gefunden",
  "请输入分类名称": "Bitte geben Sie den Kategorienamen ein",
  "分类排序不能为空": "Kategorienreihenfolge darf nicht leer sein",
  "分类排序必须为数字": "Die Kategorienreihenfolge muss eine Nummer sein",
  "正在翻译，请稍后": "übersetzung läuft, bitte warten",
  "多语言翻译": "Multilinguale übersetzung",
  "修改分类": "Kategorie bearbeiten",
  "翻译": "übersetzung",
  "分类图片": "Kategoriebild",
  "外卖商品": "Außer-Haus-Waren",
  "店内商品": "Im-Store-Waren",
  "商品管理": "Warenmanagement",
  "分类管理": "Kategorienverwaltung",
  "上架中": "Auf dem Markt",
  "下架": "Vom Regal nehmen",
  "商品名称": "Warenname",
  "请输入商品名称": "Bitte geben Sie den Warennamen ein",
  "添加产品": "Produkt hinzufügen",
  "全部": "Alle",
  "产品": "Produkt",
  "实际销量": "Tatsächlicher Umsatz",
  "库存": "Bestand",
  "发布时间": "Veröffentlichungszeitpunkt",
  "销售价": "Verkaufspreis",
  "下架中": "Abgenommen",
  "强制下架": "Zwangsvom-Regal-nehmen",
  "重新上架": "Erneut ins Regal stellen",
  "上架": "Ins Regal stellen",
  "确认要": "Bestätigen",
  "成功": "Erfolg",
  "删除成功": "Erfolgreich gelöscht",
  "请先选择一个选项": "Bitte wöhlen Sie zuerst eine Option",
  "正在完成翻译，请稍后操作": "übersetzung wird abgeschlossen, bitte später fortfahren",
  "请检查表单的必填项是否全部填写": "Bitte überprüfen Sie, ob alle erforderlichen Felder im Formular ausgefüllt sind",
  "补全成功": "Ergänzung erfolgreich",
  "主语言选择": "Hauptsprachauswahl",
  "请选择主语言": "Bitte wählen Sie die Hauptsprache",
  "高级设置": "Erweiterte Einstellungen",
  "取消": "Abbrechen",
  "修改": "Ändern",
  "保存成功": "Erfolgreich gespeichert",
  "规格": "Spezifikation",
  "库存计算方式": "Bestandsberechnungsmethode",
  "下单减库存": "Bestellung zur Bestandsreduzierung",
  "特色分类": "Besondere Klassifizierung",
  "产品规格": "Produktspezifikation",
  "单规格": "Einzelne Spezifikation",
  "多规格": "Mehrere Spezifikationen",
  "此商品正在参加活动，不能修改规格": "Dieses Produkt nimmt an einer Aktion teil und kann daher nicht geändert werden",
  "基本信息": "Grundinformation",
  "AI魔法创建": "AI Magische Erstellung",
  "通过人工智能技术，可以根据商品名称自动填写商品详细信息，如配料、卖点、口味等。": "Durch künstliche Intelligenztechnologie kann basierend auf dem Produktnamen automatisch detaillierte Produktinformationen wie Zutaten, Verkaufsargumente, Geschmack usw. ausgefüllt werden.",
  "所属分类": "Zugehörige Kategorie",
  "请选择商品分类": "Bitte wählen Sie die Produktkategorie",
  "请填写商品详情": "Bitte geben Sie die Produktinformationen ein",
  "商品详情": "Produktdetails",
  "换一换": "Ändern",
  "产品价格": "Produktpreis",
  "请填写产品价格": "Bitte geben Sie den Produktpreis ein",
  "请填写包装费": "Bitte geben Sie die Verpackungsgebühr ein",
  "规格明细": "Spezifikationsdetails",
  "规格名称": "Spezifikationsname",
  "请输入内容": "Bitte geben Sie den Inhalt ein",
  "价格": "Preis",
  "添加规格": "Spezifikation hinzufügen",
  "商品图片": "Produktbild",
  "请上传商品图片": "Bitte laden Sie das Produktbild hoch",
  "从AI图库中选择": "Aus AI-Bildbibliothek auswählen",
  "使用中文从AI图库搜索": "Verwenden Sie Chinesisch, um in der AI-Bildbibliothek zu suchen",
  "AI图库": "AI-Bildbibliothek",
  "确认使用": "Verwendung bestätigen",
  "AI未识别到您的商品图片": "AI hat Ihr Produktbild nicht erkannt",
  "可在搜索框": "Im Suchfeld verfügbar",
  "更换菜品名称": "Gerichtsnamen ändern",
  "请输入菜品名称！": "Bitte geben Sie den Gerichtsnamen ein!",
  "请在主语言界面上进行操作": "Bitte führen Sie die Operation auf der Hauptsprachoberfl?che durch",
  "本商品正在参加活动，不能删除规格！": "Dieses Produkt nimmt an einer Aktion teil und daher können die Spezifikationen nicht gelöscht werden!",
  "不能再删除了": "Kann nicht mehr gelöscht werden",
  "多语言": "Mehrsprachig",
  "商品加料": "Produktzusätze",
  "添加加料": "Zusätze hinzufügen",
  "加料名称": "Zusatzname",
  "如:杯型": "Wie: Bechertyp",
  "内容": "Inhalt",
  "积分设置": "Punkte-Einstellung",
  "是否开启积分赠送": "Ist die Punktevergabe aktiviert",
  "关闭": "Schließen",
  "其他设置": "Andere Einstellungen",
  "商品状态": "Produktstatus",
  "选择商品状态": "Wählen Sie den Produktstatus",
  "初始销量": "Initiale Verkäufe",
  "商品排序": "Produktreihenfolge",
  "限购数量": "Kaufgrenzmenge",
  "每个会员购买的最大数量，0为不限购": "Höchstmenge, die jedes Mitglied kaufen kann, 0 bedeutet kein Limit",
  "会员折扣设置": "Mitgliedsrabatt-Einstellung",
  "是否开启会员折扣": "Ist der Mitgliedsrabatt aktiviert",
  "默认折扣": "Standardrabatt",
  "单独设置折扣": "Rabatt separat einstellen",
  "默认折扣：默认为用户所属会员等级的折扣率": "Standardrabatt: Standardmäßig der Rabattsatz der Mitgliedsstufe des Benutzers",
  "折扣佣金类型": "Rabattkommissionstyp",
  "百分比": "Prozentsatz",
  "固定金额": "Fester Betrag",
  "会员等级": "Mitgliedsstufe",
  "折扣": "Rabatt",
  "请输入折扣": "Bitte geben Sie den Rabatt ein",
  "分销设置": "Vertriebseinstellung",
  "是否开启分销": "Ist der Vertrieb aktiviert",
  "分销规则": "Vertriebsregel",
  "平台规则": "Plattformregel",
  "单独规则": "Separate Regel",
  "平台规则：层级": "Plattformregel: Ebene",
  "1级佣金": "1. Ebene Provision",
  "2级佣金": "2. Ebene Provision",
  "3级佣金": "3. Ebene Provision",
  "分销佣金类型": "Vertriebskommissionstyp",
  "单独分销设置": "Separate Vertriebseinstellung",
  "一级佣金": "1. Ebene Provision",
  "二级佣金": "2. Ebene Provision",
  "三级佣金": "3. Ebene Provision",
  "请填写商品名称": "Bitte geben Sie den Warennamen ein",
  "你选择商品分类": "Sie wählen die Produktkategorie",
  "商品卖点": "Verkaufsargumente für das Produkt",
  "配料": "Zutaten",
  "添加项": "Element hinzufügen",
  "删除项": "Element entfernen",
  "审核状态": "Prüfstatus",
  "选择审核状态": "Wählen Sie den Prüfstatus",
  "通过": "Genehmigen",
  "未通过": "Nicht genehmigen",
  "审核备注": "Prüfvermerk",
  "请输入拒绝原因": "Bitte geben Sie den Ablehnungsgrund ein",
  "商品属性": "Produkteigenschaften",
  "添加属性": "Eigenschaften hinzufügen",
  "属性名称": "Eigenschaftsname",
  "属性值": "Eigenschaftswert",
  "至少填写两个": "Bitte füllen Sie mindestens zwei aus",
  "如:温度": "Beispiel: Temperatur",
  "口味": "Geschmack",
  "商品同步": "Produktsynchronisation",
  "同步至外卖": "Synchronisieren mit Takeaway",
  "库存数量": "Bestandsmenge",
  "请填写库存数量": "Bitte geben Sie die Bestandsmenge ein",
  "请上传分类图片": "Bitte laden Sie das Kategoriebild hoch",
  "发布": "Veröffentlichen",
  "级": "Level",
  "请填写口味": "Bitte geben Sie den Geschmack ein",
  "从AI图库搜索": "Suche in der AI-Bildbibliothek",
  "AI获取标签": "AI erhält Tags",
  "标签": "Tag",
  "添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求": "Hinzugefügte Tags können dem AI-Bestellassistenten helfen, die Bestellbedürfnisse der Kunden genauer zu verstehen",
  "同步至店内": "Synchronisieren mit im Geschäft",
  "是否同步商品至外卖": "Sollen Produkte mit Takeaway synchronisiert werden?",
  "是否同步商品至店内": "Sollen Produkte mit dem Geschäft synchronisiert werden?",
  "付款减库存": "Zahlung zur Bestandsreduzierung",
  "菜品录入使用语言": "Verwendete Sprache für die Gerichtseingabe",
  "网站主页": "Website-Startseite",
  "主题编辑": "Thema bearbeiten",
  "我的菜单": "Mein Menü",
  "添加菜单": "Menü hinzufügen",
  "菜单名称": "Menüname",
  "图标": "Icon",
  "是否显示": "Anzeigen?",
  "更新时间": "Aktualisierungszeit",
  "正在处理": "Verarbeitung läuft",
  "处理失败，请重试": "Verarbeitung fehlgeschlagen, bitte erneut versuchen",
  "此操作将永久删除该记录, 是否继续?": "Diese Aktion löscht den Datensatz dauerhaft. Möchten Sie fortfahren?",
  "确定": "Bestätigen",
  "主题选择": "Themenwahl",
  "主题一": "Thema Eins",
  "主题二": "Thema Zwei",
  "主题三": "Thema Drei",
  "主题四": "Thema Vier",
  "主题五": "Thema Fünf",
  "主题六": "Thema Sechs",
  "主页预览": "Startseiten-Vorschau",
  "撤回": "Zurückziehen",
  "获取预览网站失败,请检查网络或联系管理员": "Vorschau-Website konnte nicht abgerufen werden, bitte überprüfen Sie das Netzwerk oder kontaktieren Sie den Administrator",
  "撤回成功": "Erfolgreich zurückgezogen",
  "编辑菜单": "Menü bearbeiten",
  "请输入广告标题": "Bitte geben Sie den Anzeigentitel ein",
  "图标大小为": "Symbolgröße beträgt",
  "显示": "Anzeigen",
  "隐藏": "Verstecken",
  "请输入数字": "Bitte geben Sie eine Zahl ein",
  "链接": "Verknüpfung",
  "选择链接": "Verknüpfung auswählen",
  "提交": "Einreichen",
  "请输入菜单名称": "Bitte geben Sie den Menünamen ein",
  "请选择链接地址": "Bitte wählen Sie die Verknüpfungsadresse",
  "链接到": "Verknüpfen mit",
  "请上传图标": "Bitte laden Sie das Symbol hoch",
  "确定要删除吗?": "Möchten Sie wirklich löschen?",
  "次浏览": "Ansichten",
  "每日必拼": "Tägliches Pflichtteam",
  "更多": "Mehr",
  "2人团": "2-Personen-Gruppe",
  "去开团": "Gruppe starten",
  "活动砍价": "Aktions-Sonderpreis",
  "已抢2件": "Bereits 2 Stück gekauft",
  "立即砍价": "Jetzt handeln",
  "满": "Vollständig",
  "可用": "Verfügbar",
  "立即领取": "Jetzt empfangen",
  "热门直播": "Beliebte Live-übertragung",
  "已售": "Verkauft",
  "限时秒杀": "Begrenzte Zeit zum Töten",
  "搜索商品": "Produkte durchsuchen",
  "线下门店": "Lokales Geschäft",
  "门店地址": "Geschäftsadresse",
  "联系电话": "Kontaktnummer",
  "您的浏览器不支持 video 标签": "Ihr Browser unterstützt das Video-Tag nicht",
  "店家正在直播、折扣套餐秒杀中": "Der Ladeninhaber sendet live, Discount-Pakete und Sekunden-Töten",
  "进入": "Eintreten",
  "至少保留一个": "Mindestens eines behalten",
  "咨询分类": "Beratungskategorie",
  "全部分类": "Alle Kategorien",
  "显示数量": "Anzeigemenge",
  "咨询数据请到": "Für Beratungsdaten gehen Sie bitte zu",
  "插件": "Plugin",
  "资讯": "Informationen",
  "显示类型": "Anzeigetyp",
  "有图模式": "Mit Bildmodus",
  "无图模式": "Ohne Bildmodus",
  "组件样式": "Komponentenstil",
  "显示内容": "Inhalt anzeigen",
  "拼团价格": "Gruppenkampfpreis",
  "划线价格": "Durchgestrichener Preis",
  "指示点颜色": "Indikatorpunkt-Farbe",
  "重置": "Zurücksetzen",
  "切换时间": "Wechselzeit",
  "轮播图自动切换的间隔时间，单位：毫秒": "Intervallzeit für Auto-Wechsel der Karussellbilder, Einheit: Millisekunden",
  "建议尺寸": "Empfohlene Größe",
  "链接地址": "Verknüpfungsadresse",
  "添加一个": "Einen hinzufügen",
  "标题内容": "Titelinhalt",
  "文字内容": "Textinhalt",
  "链接名称": "Verknüpfungsname",
  "正在砍价": "Verhandeln",
  "商品原价": "Originalpreis des Artikels",
  "背景颜色": "Hintergrundfarbe",
  "组件高度": "Komponentenhöhe",
  "上下边距": "Obere und untere Abgrenzung",
  "线条样式": "Linienstil",
  "实线": "Durchgezogene Linie",
  "虚线": "Gestrichelte Linie",
  "点状": "Gepunktet",
  "线条颜色": "Linienfarbe",
  "线条高度": "Linienhöhe",
  "左右边距": "Linke und rechte Abgrenzung",
  "标题": "Titel",
  "颜色": "Farbe",
  "每行数量": "Anzahl pro Zeile",
  "1个": "1 Stück",
  "2个": "2 Stück",
  "文字颜色": "Textfarbe",
  "公告图标": "Ankündigungssymbol",
  "公告内容": "Ankündigungsinhalt",
  "商品来源": "Produktquelle",
  "自动获取": "Automatisch abrufen",
  "手动选择": "Manuelle Auswahl",
  "综合": "Allgemein",
  "商品列表": "Produktliste",
  "选择产品": "Produkt auswählen",
  "列表平铺": "Liste pflastern",
  "横向滑动": "Horizontal scrollen",
  "分列数量": "Spaltenanzahl",
  "单列": "Eine Spalte",
  "两列": "Zwei Spalten",
  "三列": "Drei Spalten",
  "商品价格": "Produktpreis",
  "商品销量": "Produktverkäufe",
  "提示文字": "Hinweistext",
  "搜索框样式": "Suchfeldstil",
  "方形": "Quadratisch",
  "圆角": "Abgerundet",
  "圆弧": "Bogenförmig",
  "文字对齐": "Textausrichtung",
  "居左": "Links ausgerichtet",
  "居中": "Zentriert",
  "居右": "Rechts ausgerichtet",
  "秒杀价格": "Sekunden-Preis",
  "底边距": "Unterer Rand",
  "右边距": "Rechter Rand",
  "不透明度": "Deckkraft",
  "客服类型": "Kundendiensttyp",
  "在线聊天": "Online-Chat",
  "拨打电话": "Telefonanruf",
  "电话号码": "Telefonnummer",
  "客服图标": "Kundendienstsymbol",
  "标题类型": "Titeltyp",
  "页面名称": "Seitenname",
  "页面名称仅用于后台查找": "Seitenname wird nur für die Backend-Suche verwendet",
  "分享标题": "Freigabetitel",
  "小程序端转发时显示的标题": "Titel, der beim Weiterleiten über die Mini-Programm-Seite angezeigt wird",
  "文章数据请到": "Artikeldaten bitte hier einsehen",
  "内容管理": "Inhaltsverwaltung",
  "文章列表": "Artikelliste",
  "中管理": "In",
  "单行": "Einzeilig",
  "两行": "Zweizeilig",
  "门店列表": "Filialliste",
  "选择门店": "Filiale auswählen",
  "展示数量": "Anzeigemenge",
  "视频高度": "Videogröße",
  "滑块可用左右方向键精确调整": "Der Schieberegler kann genau mit den links und rechts Tasten angepasst werden",
  "视频封面": "Video-Cover",
  "视频地址": "Videoadresse",
  "自动播放": "Automatische Wiedergabe",
  "布局方式": "Layout-Methode",
  "堆积两列": "Zwei Spalten stapeln",
  "堆积三列": "Drei Spalten stapeln",
  "堆积四列": "Vier Spalten stapeln",
  "橱窗样式": "Vitrinen-Stil",
  "橱窗样式最多显示四张图片，超出隐藏": "Vitrinenstil zeigt maximal vier Bilder, die restlichen werden ausgeblendet",
  "请确保所有图片的尺寸/比例相同": "Stellen Sie sicher, dass alle Bilder die gleiche Größe/Proportion haben",
  "标题文字": "Titeltext",
  "组件库": "Komponenten-Bibliothek",
  "媒体组件": "Medienkomponente",
  "商城组件": "Einkaufszentrum-Komponente",
  "工具组件": "Werkzeugkomponente",
  "登录组件": "Anmeldekomponente",
  "资讯管理": "Informationsverwaltung",
  "添加资讯": "Information hinzufügen",
  "资讯ID": "Informations-ID",
  "封面": "Cover",
  "资讯标题": "Informations-Titel",
  "虚拟阅读量": "Virtuelle Leseanzahl",
  "实际阅读量": "Tatsächliche Leseanzahl",
  "资讯排序": "Informationsreihenfolge",
  "已取消删除": "Löschung abgebrochen",
  "请输入文章标题": "Bitte geben Sie den Artikel-Titel ein",
  "描述": "Beschreibung",
  "请输入文章描述": "Bitte geben Sie die Artikelbeschreibung ein",
  "缩略图": "Miniaturansicht",
  "资讯状态": "Informationsstatus",
  "资讯内容": "Informationsinhalt",
  "分类ID": "Kategorie-ID",
  "编辑分类": "Kategorie bearbeiten",
  "恭喜你，修改成功": "Herzlichen Glückwunsch, änderung erfolgreich",
  "编辑资讯": "Information bearbeiten",
  "份": "Portion",
  "中文": "Chinesisch",
  "英语": "Englisch",
  "意大利语": "Italienisch",
  "德语": "Deutsch",
  "西班牙语": "Spanisch",
  "法语": "Französisch",
  "克罗地亚": "Kroatisch",
  "斯洛文尼亚": "Slowenisch",
  "匈牙利语": "Ungarisch",
  "规格库": "Spezifikationsbibliothek",
  "属性库": "Attributbibliothek",
  "加料库": "Zusatzstoffbibliothek",
  "规格名": "Spezifikationsname",
  "批量删除": "Massenlöschung",
  "请输入规格名称": "Bitte geben Sie den Spezifikationsnamen ein",
  "删除后不可恢复，确认删除吗?": "Kann nach dem Löschen nicht wiederhergestellt werden, Bestätigen Sie die Löschung?",
  // =========== 建店必做 end ==================

  // ================ 订单 start ================
  "实时概况": "Echtzeitüberblick",
  "营业总额": "Gesamtumsatz",
  "有效订单": "Gültige Bestellungen",
  "退款金额": "Rückerstattungsbetrag",
  "销量排行榜": "Verkaufsrangliste",
  "销售额排行榜": "Umsatzrangliste",
  "商品排行榜": "Produktrangliste",
  "订单号": "Bestellnummer",
  "请输入订单号": "Bitte geben Sie die Bestellnummer ein",
  "配送方式": "Liefermethode",
  "起始时间": "Startzeit",
  "开始日期": "Startdatum",
  "结束日期": "Enddatum",
  "导出": "Exportieren",
  "全部订单": "Alle Bestellungen",
  "未付款": "Nicht bezahlt",
  "已完成": "Abgeschlossen",
  "订单信息": "Bestellinformationen",
  "下单时间": "Bestellzeit",
  "取消申请中": "Stornierungsantrag in Bearbeitung",
  "实付款": "Tatsächliche Zahlung",
  "含服务费": "Inklusive Servicegebühr",
  "含包装费": "Inklusive Verpackungsgebühr",
  "买家": "Käufer",
  "门店名称": "Geschäftsname",
  "出餐状态": "Essensstatus",
  "准备中": "In Vorbereitung",
  "出餐中": "Kochen",
  "待取餐": "Warten auf Abholung",
  "交易状态": "Transaktionsstatus",
  "支付方式": "Zahlungsmethode",
  "订单详情": "Bestelldetails",
  "出餐": "Essen servieren",
  "退款": "Rückerstattung",
  "核销": "Verifizieren",
  "确定要出餐吗?": "Sind Sie sicher, dass Sie das Essen servieren mächten?",
  "确定要核销吗?": "Sind Sie sicher, dass Sie verifizieren mächten?",
  "恭喜你，操作成功": "Herzlichen Glückwunsch, Vorgang erfolgreich",
  "已取消核销": "Verifizierung storniert",
  "订单来源": "Bestellquelle",
  "订单金额": "Bestellbetrag",
  "配送费": "Liefergebühr",
  "服务费": "Servicegebühr",
  "优惠券抵扣": "Gutscheinabzug",
  "积分抵扣": "Punktabzug",
  "满减金额": "Betrag bei Mindestbestellung",
  "优惠金额": "Rabattbetrag",
  "实付款金额": "Tatsächlicher Zahlungsbetrag",
  "用餐方式": "Essensart",
  "取餐时间": "Abholzeit",
  "桌号": "Tischnummer",
  "修改价格": "Preis ändern",
  "门店信息": "Geschäftsinformationen",
  "商品信息": "Produktinformationen",
  "会员折扣价": "Mitgliedsrabattpreis",
  "购买数量": "Kaufmenge",
  "商品总价": "Gesamtpreis der Waren",
  "收货信息": "Empfangsinformationen",
  "收货人": "Empfänger",
  "收货电话": "Telefon des Empfängers",
  "收货地址": "Lieferadresse",
  "备注": "Bemerkung",
  "自提用户信息": "Selbstabholer-Informationen",
  "用户信息": "Benutzerinformationen",
  "联系手机": "Kontakttelefon",
  "付款信息": "Zahlungsinformationen",
  "应付款金额": "Zu zahlender Betrag",
  "支付流水号": "Zahlungsreferenznummer",
  "付款状态": "Zahlungsstatus",
  "付款时间": "Zahlungszeit",
  "发货信息": "Versandinformationen",
  "发货状态": "Versandstatus",
  "取消信息": "Stornierungsinformationen",
  "商家备注": "Hinweis des Verkäufers",
  "门店自提核销": "Geschäftsabholungsbuchung",
  "核销员": "Buchungsleiter",
  "核销状态": "Buchungsstatus",
  "已核销": "Bereits verifiziert",
  "核销时间": "Buchungszeit",
  "返回上一页": "Zurück zur vorherigen Seite",
  "确认发货": "Lieferung bestätigen",
  "确认审核": "Prüfung bestätigen",
  "请选择物流公司": "Bitte wählen Sie das Logistikunternehmen",
  "请填写物流单号": "Bitte geben Sie die Logistiknummer ein",
  "恭喜你，发货成功": "Herzlichen Glückwunsch, Versand erfolgreich",
  "恭喜你，审核成功": "Herzlichen Glückwunsch, Prüfung erfolgreich",
  "订单价格修改": "Bestellpreisänderung",
  "运费金额": "Frachtbetrag",
  "最终付款价": "Endpreis",
  "取消订单": "Bestellung stornieren",
  "请输入备注": "Bitte geben Sie eine Bemerkung ein",
  "请输入退款金额": "Bitte geben Sie den Rückerstattungsbetrag ein",
  "确认退款?": "Rückerstattung bestätigen?",
  "已取消退款": "Rückerstattung storniert",
  "含配送费": "Inklusive Liefergebühr",
  "确认送达": "Lieferung bestätigen",
  "是否确认此操作?": "Möchten Sie diese Aktion bestätigen?",
  "配送状态": "Lieferstatus",
  "备注信息": "Bemerkungsinformationen",
  "期望配送时间": "Erwartete Lieferzeit",
  "订单状态": "Bestellstatus",
  "骑手姓名": "Name des Fahrers",
  "骑手电话": "Telefon des Fahrers",
  "操作时间": "Vorgangszeit",
  "详情": "Details",
  "此操作将确认送达, 是否继续?": "Diese Aktion bestätigt die Lieferung. Möchten Sie fortfahren?",
  "配送时间": "Lieferzeit",
  "配送信息": "Lieferinformationen",
  "配送类型": "Lieferart",
  "配送距离": "Lieferentfernung",
  "配送员": "Lieferant",
  "配送电话": "Lieferantentelefon",
  "配送费用": "Liefergebühren",
  "送达时间": "Ankunftszeit",
  "取消原因": "Stornierungsgrund",
  "请输入取消原因": "Bitte geben Sie einen Stornierungsgrund ein",
  "米": "Meter",
  // ================ 订单 end  ================

  // ================= 门店 start ==============
  "门店ID": "Filialen-ID",
  "联系地址": "Kontaktadresse",
  "下载二维码": "QR-Code herunterladen",
  "H5网页": "H5-Webseite",
  "添加门店": "Einrichtung integrieren",
  "设置": "Konfiguration",
  "恭喜你，门店删除成功": "Herzlichen Glückwunsch, erfolgreiche Löschung des Geschäfts",
  "请输入地点": "Bitte geben Sie den Standort ein",
  "添加": "Integrieren",
  "等级": "Grad",
  "请选择会员等级": "Bitte wählen Sie den Mitgliedsgrad",
  "性别": "Geschlecht",
  "请选择性别": "Bitte wählen Sie das Geschlecht",
  "微信昵称": "WeChat-Spitzname",
  "请输入微信昵称": "Bitte geben Sie den WeChat-Spitznamen ein",
  "微信头像": "WeChat-Profilbild",
  "昵称": "Spitzname",
  "用户余额": "Benutzerbilanz",
  "累积消费金额": "Akkumulierter Verbrauchsbetrag",
  "注册时间": "Anmeldezeit",
  "分钟后自动清理桌台": "Tische automatisch nach Minuten reinigen",
  "扫桌码点餐和收银桌台点餐定时清台时间": "Geplante Tischreinigungszeit für das Scannen von Tischcodes zum Bestellen und Kassen-Tische",
  "到店自提": "Abholung im Geschäft",
  "打包带走": "Mitnehmen",
  "店内就餐": "Im Restaurant essen",
  "外卖配送至少选择一种！": "Wählen Sie mindestens eine Liefermethode für die Mitnahme!",
  "店内配置至少选择一种！": "Wählen Sie mindestens eine In-Store-Konfiguration!",
  "恭喜你，设置成功": "Herzlichen Glückwunsch, erfolgreiche Konfiguration",
  "恭喜你，门店修改成功": "Herzlichen Glückwunsch, erfolgreiche änderung des Gesch?fts",
  "门店": "Geschäft",
  "提现金额": "Auszahlungsbetrag",
  "打款方式": "Zahlungsmethode",
  "待审核": "Ausstehende überprüfung",
  "审核通过": "Genehmigt",
  "驳回": "Abgelehnt",
  "原因": "Grund",
  "已打款": "Zahlung erfolgt",
  "审核": "überprüfung",
  "确认打款": "Zahlung bestätigen",
  "确认要打款吗?": "Zahlung bestätigen?",
  "供应商名称": "Lieferantname",
  "余额变动场景": "Bilanzänderungsszenario",
  "收入": "Einkommen",
  "提现": "Auszahlung",
  "起始日期": "Startdatum",
  "变动金额": "Geänderter Betrag",
  "描述/说明": "Beschreibung/Erklärung",
  "创建时间": "Erstellungszeit",
  "恭喜你，门店添加成功": "Herzlichen Glückwunsch, erfolgreiche Hinzufügung des Geschäfts",
  "驳回原因": "Grund für die Ablehnung",
  "提现审核": "Auszahlungsprüfung",
  "小票打印设置": "Bon-Druckeinstellung",
  "是否开启商户小票打印": "Aktivieren des Bon-Drucks für Händler",
  "选择打印机": "Drucker auswählen",
  "是否开启顾客小票打印": "Aktivieren des Bon-Drucks für Kunden",
  "选择打印机二": "Drucker Zwei auswählen",
  "是否开启厨房小票打印": "Aktivieren des Bon-Drucks für die Küche",
  "选择打印机三": "Drucker Drei auswählen",
  "恭喜你，打印设置成功": "Herzlichen Glückwunsch, erfolgreiche Druckeinstellung",
  "小票打印机列表": "Liste der Bon-Drucker",
  "打印机ID": "Drucker-ID",
  "打印机名称": "Druckername",
  "编辑小票打印机": "Bon-Drucker bearbeiten",
  "打印机类型": "Druckertyp",
  "米泰打印机": "Mettai-Drucker",
  "打印机编号": "Drucker-Seriennummer",
  "打印机编号为9位数字，查看米泰打印机底部贴纸上面的编号": "Die Drucker-Seriennummer besteht aus 9 Ziffern. überprüfen Sie die Nummer auf dem Aufkleber über der Unterseite des Mettai-Druckers",
  "打印机秘钥": "Drucker-Code",
  "打印联数": "Druckkopien",
  "同一订单，打印的次数": "Anzahl der Drucke für dieselbe Bestellung",
  "排序": "Sortierung",
  "数字越小越靠前": "Je kleiner die Zahl, desto höher die Priorität",
  "新增小票打印机": "Neuen Bon-Drucker hinzufügen",
  "恭喜你，添加成功": "Herzlichen Glückwunsch, erfolgreiche Hinzufügung",
  "配送方式设置": "Liefermethode-Einstellung",
  "商家配送": "Händlerlieferung",
  "自动配送时间(分钟)": "Automatische Lieferzeit (Minuten)",
  "设置0不自动配送，下单后未配送，设置时间后自动操作配送": "Einstellung auf 0 bedeutet keine automatische Lieferung. Nach der Bestellung ohne Lieferung wird nach der festgelegten Zeit automatisch geliefert",
  "商户编号": "Händlernummer",
  "门店编号": "Filialen-ID",
  "环境": "Umgebung",
  "测试环境": "Testumgebung",
  "正式环境": "Produktionsumgebung",
  "回调地址": "Rückrufadresse",
  "运营城市": "Betriebsstadt",
  "恭喜你，上传设置成功": "Herzlichen Glückwunsch, erfolgreiche Upload-Einstellung",
  "菜品打印列表": "Speisekarten-Druckliste",
  "名称": "Name",
  "打印类型": "Drucktyp",
  "外卖": "Mitnehmen",
  "店内": "Im Restaurant",
  "菜品打印": "Speisekarten-Druck",
  "是否开启": "Aktivieren",
  "配送打印": "Lieferdruck",
  "店内打印": "In-Restaurant-Druck",
  "打印方式": "Druckmethode",
  "付款打印": "Zahlungsdruck",
  "下单打印": "Bestelldruck",
  "商品分组": "Produktgruppierung",
  "男": "Männlich",
  "女": "Weiblich",
  "未知": "Unbekannt",
  "文件管理": "Dateiverwaltung",
  "移动至": "Verschieben nach",
  "点击上传": "Klicken zum Hochladen",
  "删除失败": "Löschen fehlgeschlagen",
  "请选择文件": "Bitte wählen Sie eine Datei",
  "确定移动选中的文件吗？, 是否继续?": "Möchten Sie die ausgewählten Dateien verschieben? Wollen Sie fortfahren?",
  "只能上传图片！": "Nur Bilder können hochgeladen werden!",
  "上传文件只能是图片格式!": "Die hochgeladene Datei muss im Bildformat sein!",
  "上传文件大小不能超过 2MB!": "Die Größe der hochgeladenen Datei darf 2 MB nicht überschreiten!",
  "请查看/裁切其它上传图片!": "Bitte sehen Sie sich andere hochgeladene Bilder an/beschneiden Sie sie!",
  "图片上传中,请等待": "Bild wird hochgeladen, bitte warten",
  "当前图片上传失败!": "Aktuelles Bild konnte nicht hochgeladen werden!",
  "本次上传图片失败": "Dieses Mal ist das Hochladen des Bildes fehlgeschlagen",
  "本次最多只能上传1个文件": "Es kann maximal 1 Datei gleichzeitig hochgeladen werden",
  "裁剪图片": "Bild zuschneiden",
  "选择优惠券": "Gutschein auswählen",
  "数量": "Menge",
  "无限制": "Unbegrenzt",
  "请输入等级名称": "Bitte geben Sie den Gradnamen ein",
  "长度在3到5个字符": "Die Länge sollte zwischen 3 und 5 Zeichen liegen",
  "错了哦，这是一条错误消息": "Oops, dies ist eine Fehlermeldung",
  "增加税率": "Steuersatz hinzufügen",
  "税率分类": "Steuerklassifikation",
  "请输入税率分类": "Bitte geben Sie die Steuerklassifikation ein",
  "自定义税率分类": "Benutzerdefinierte Steuerklassifikation",
  "请输入税率值": "Bitte geben Sie den Steuersatz ein",
  "单位是": "Die Einheit ist",
  "适用菜品分类": "Anwendbare Speisenkategorie",
  "请选择菜品分类": "Bitte w?hlen Sie die Speisekategorie",
  "修改税率信息": "Steuersatzinformationen ändern",
  "分类名称不能为空": "Kategorienname darf nicht leer sein",
  "提现设置": "Auszahlungseinstellungen",
  "是否开启提现": "Auszahlungen aktivieren",
  "注：如开启则移动端显示余额提现": "Hinweis: Wenn aktiviert, wird die Option zum Abheben des Guthabens auf dem Mobilgerät angezeigt",
  "提现比例": "Auszahlungsprozentsatz",
  "注：提现比例请填写数字0~100": "Hinweis: Bitte geben Sie einen Auszahlungsprozentsatz zwischen 0 und 100 ein",
  "例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)":  "Beispiel: Abhebungsbetrag (100,00 ¥) * Auszahlungsprozentsatz (100%) = Tatsächlich erhalten (100€)",
  "最低提现金额": "Mindestauszahlungsbetrag",
  "注：最低提现金额多少元": "Hinweis: Was ist der Mindestauszahlungsbetrag in Yuan?",
  "请选择状态": "Bitte wählen Sie den Status",
  "提现方式": "Auszahlungsmethode",
  "请选择提现方式": "Bitte wählen Sie eine Auszahlungsmethode",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "银行卡": "Bankkarte",
  "请输入用户ID": "Bitte geben Sie die Benutzer-ID ein",
  "请输入昵称/姓名/手机号": "Bitte geben Sie den Spitznamen/Namen/Mobiltelefonnummer ein",
  "提现信息": "Auszahlungsinformationen",
  "支付宝名称": "Alipay Name",
  "支付宝账号": "Alipay-Konto",
  "银行名称": "Bankname",
  "开户名": "Kontoinhaber",
  "银行卡号": "Bankkartennummer",
  "申请时间": "Antragszeit",
  "审核时间": "überprüfungszeit",
  "微信付款": "WeChat-Zahlung",
  "该操作 将使用微信支付企业付款到零钱功能，确定打款吗？": "Dieser Vorgang wird die Funktion zur Zahlung von Unternehmen über WeChat zur Geldbörse verwenden. Sind Sie sicher, dass Sie fortfahren möchten?",
  "添加充值套餐": "Top-up-Paket hinzufügen",
  "套餐名称": "Paketname",
  "请输入套餐名称": "Bitte geben Sie den Paketnamen ein",
  "请输入支付金额": "Bitte geben Sie den Zahlungsbetrag ein",
  "请输入赠送金额": "Bitte geben Sie den Geschenkbetrag ein",
  "请输入到账金额": "Bitte geben Sie den Betrag auf dem Konto ein",
  "请输入排序": "Bitte geben Sie die Sortierreihenfolge ein",
  "用户ID": "Benutzeridentifikation",
  "会员卡管理": "Verwaltung von Mitgliedskarten",
  "领取记录": "Empfangsprotokolle",
  "删除记录": "Datensatz löschen",
  "请输入关键词": "Bitte geben Sie das Stichwort ein",
  "过期": "Abgelaufen",
  "有效": "Gültig",
  "客户信息": "Kundendaten",
  "会员卡名称": "Name der Mitgliedskarte",
  "有效期": "Gültigkeitsdauer",
  "折": "Rabatt",
  "领取时间": "Empfangszeit",
  "延期": "Verlängerung",
  "撤销": "Stornieren",
  "添加会员卡": "Mitgliedskarte hinzufügen",
  "启用": "Aktivieren",
  "月": "Monat",
  "永久有效": "Dauerhaft gültig",
  "领取数量": "Anzahl der Empfänger",
  "发卡": "Karte ausgeben",
  "领取设置": "Einstellungen für Empfang",
  "请检查必填项是否填写完整": "Bitte prüfen Sie, ob die Pflichtfelder vollständig ausgefüllt sind",
  "领取人数": "Anzahl der Empfänger",
  "删除时间": "Löschzeit",
  "请填写有效期": "Bitte geben Sie die Gültigkeitsdauer ein",
  "有效期限（月），0为永久有效": "Gültigkeitsdauer (in Monaten), 0 für unbegrenzte Gültigkeit",
  "请填写价格": "Bitte geben Sie den Preis ein",
  "用户购买会员卡需要支付的金额，0为用户免费领取": "Der Betrag, den Benutzer zahlen müssen, um die Mitgliedskarte zu erwerben, 0 für kostenlose Ausgabe an Benutzer",
  "使用须知": "Nutzungsrichtlinien",
  "请填写使用须知": "Bitte geben Sie die Verwendungshinweise ein",
  "请填写会员卡名称": "Bitte geben Sie den Namen der Mitgliedskarte ein",
  "卡片类型": "Kartentyp",
  "卡片样式": "Kartenstil",
  "请填写排序": "Bitte geben Sie die Sortierreihenfolge ein",
  "会员权益": "Mitgliedschaftsvorteile",
  "无折扣": "Kein Rabatt",
  "请填写折扣": "Bitte geben Sie den Rabatt ein",
  "开卡赠送": "Geschenk zur Kartenausgabe",
  "优惠券": "Coupon",
  "请填写积分数量": "Bitte geben Sie die Punktemenge ein",
  "请填写余额数量": "Bitte geben Sie den Betrag auf dem Konto ein",
  "请填写优惠券": "Bitte geben Sie den Gutschein ein",
  "添加优惠券": "Gutschein hinzufügen",
  "券名称": "Gutscheinname",
  "每人领取数量": "Menge pro Person",
  "选择优惠券弹出层": "Auswahl des Popups für Gutscheine",
  "您已经选择了十五张优惠券，若要更换请删除其他优惠券！": "Sie haben bereits fünfzehn Gutscheine ausgewählt. Bitte l?schen Sie andere, wenn Sie sie ersetzen möchten!",
  "产品编码": "Produktcode",
  "请填写产品编码": "Bitte geben Sie den Produktcode ein",
  "产品划线价": "Produktlistenpreis",
  "请填写产品划线价": "Bitte geben Sie den Produktlistenpreis ein",
  "商品重量": "Produktgewicht",
  "请填写商品重量": "Bitte geben Sie das Produktgewicht ein",
  "批量设置": "Masseneinstellungen",
  "划线价": "Listenpreis",
  "重量": "Gewicht",
  "应用": "Anwenden",
  "规格图片": "Spezifikationsbild",
  "规格值": "Spezifikationswert",
  "请输入规格值": "Bitte geben Sie den Spezifikationswert ein",
  "请填写规则名或规则值": "Bitte geben Sie den Regelnamen oder den Regelwert ein",
  "规格值不能为空": "Spezifikationswert darf nicht leer sein",
  "卡名称": "Kartenname",
  "卡ID": "Kartenidentifikation",
  "无": "Keine",
  "选择会员": "Mitglied auswählen",
  "恭喜你，发卡成功": "Herzlichen Glückwunsch, Kartenversand erfolgreich",
  "副卡数": "Anzahl der Zusatzkarten",
  "张": "Stück",
  "选择日期":  "Datum auswählen",
  "签到设置": "Check-in-Einstellungen",
  "签到记录": "Check-in-Protokolle",
  "是否开启签到有礼": "Belohnungen für Check-ins aktivieren",
  "每日签到固定奖励":  "Feste Belohnung für tägliche Check-ins",
  "每日签到送":  "Tägliche Check-in-Belohnung",
  "递增奖励": "Inkrementelle Belohnung",
  "有": "Ja",
  "第二天起递增奖励": "Inkrementelle Belohnung ab dem zweiten Tag",
  "第": "Tag",
  "天起不再递增": "Keine weitere Steigerung ab diesem Tag",
  "连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算）": "Zusätzliche Belohnungen für fortlaufende Check-ins (Wenn die maximale Anzahl zusätzlicher Belohnungstage erreicht ist, erhalten nachfolgende Check-ins keine zusätzlichen Belohnungen mehr; nach einem versäumten Check-in beginnt die Zählung erneut)",
  "额外奖励": "Zusätzliche Belohnung",
  "连续签到": "Kontinuierliche Check-ins",
  "请输入连续签到天数": "Bitte geben Sie die Anzahl aufeinanderfolgender Check-in-Tage ein",
  "积分奖励": "Punktebelohnungen",
  "送": "Geschenk",
  "请输入连续签到天数的积分": "Bitte geben Sie die Punkte für aufeinanderfolgende Check-in-Tage ein",
  "规则": "Regeln",
  "规则说明":  "Erklärung der Regeln",
  "请添加至少一项额外奖励！": "Bitte fügen Sie mindestens eine zusätzliche Belohnung hinzu!",
  "天数不能为空！": "Tage dürfen nicht leer sein!",
  "请输入连续签到积分数！": "Bitte geben Sie die Punkte für aufeinanderfolgende Check-ins ein!",
  "每日签到送积分有误": "Fehler bei der Punktebelohnung für das tägliche Check-in",
  "请输入第二天起递增积分数": "Bitte geben Sie die inkrementellen Punkte ab dem zweiten Tag ein",
  "请输入第几天不再递增": "Bitte geben Sie den Tag ein, an dem die Inkrementierung endet",
  "恭喜你，保存成功": "Herzlichen Glückwunsch, Speichern erfolgreich",
  "连续签到天数": "Anzahl aufeinanderfolgender Check-in-Tage",
  "不限": "Unbegrenzt",
  "签到时间": "Check-in-Zeit",
  "时间": "Zeit",
  "请输入用户昵称": "Bitte geben Sie den Benutzernamen ein",
  "签到日期": "Check-in-Datum",
  "活动奖品": "Aktivitätspreise",
  "取号记录": "Nummernreservierungsprotokolle",
  "桌号管理": "Tischverwaltung",
  "取号设置": "Nummernreservierungseinstellungen",
  "请输入手机号": "Bitte geben Sie die Telefonnummer ein",
  "待叫号": "Zu rufende Nummer",
  "已入座": "Eingenommen",
  "已过号": "Verpasst",
  "已取消": "Abgebrochen",
  "就餐号": "Essensnummer",
  "就餐人数": "Anzahl der Gäste",
  "桌位名称": "Tischname",
  "取号时间": "Zeitpunkt der Nummernreservierung",
  "待取号": "Zu reservieren",
  "是否开启打印": "Drucken aktivieren",
  "须知": "Anweisungen",
  "请输入须知": "Bitte geben Sie die Anweisungen ein",
  "商家说明": "Beschreibung des Händlers",
  "请输入商家说明": "Bitte geben Sie die Beschreibung des Händlers ein",
  "取号规则": "Regeln für die Nummernreservierung",
  "等待时间": "Wartezeit",
  "人数最小值": "Minimale Personenanzahl",
  "人数最大值": "Maximale Personenanzahl",
  "等待时间(分钟)": "Wartezeit (Minuten)",
  "请输入桌位名称": "Bitte geben Sie den Tischnamen ein",
  "请输入人数最小值": "Bitte geben Sie die minimale Personenanzahl ein",
  "请输入人数最大值": "Bitte geben Sie die maximale Personenanzahl ein",
  "请输入等待时间": "Bitte geben Sie die Wartezeit ein",
  "商品设置": "Produkteinstellungen",
  "兑换记录": "Einlösungsprotokolle",
  "活动名称": "Aktivit?tsname",
  "请输入活动名称": "Bitte geben Sie den Aktivitätsnamen ein",
  "活动列表":  "Aktivitätsliste",
  "添加活动":  "Aktivität hinzufügen",
  "活动价格":  "Aktivitätspreis",
  "发放数量": "Verteilungsmenge",
  "参与人数": "Teilnehmerzahl",
  "终止": "Beenden",
  "购买记录": "Kaufprotokolle",
  "新增活动会场": "Neuen Veranstaltungsort hinzufügen",
  "活动标题":  "Aktivitätstitel",
  "请输入活动标题": "Bitte geben Sie den Aktivitätstitel ein",
  "活动日期": "Aktivitätsdatum",
  "礼包设置": "Geschenkpaketkonfiguration",
  "优惠券id": "Gutschein-ID",
  "购买设置": "Kaufeinstellungen",
  "购买金额": "Kaufbetrag",
  "会员购买等级": "Kaufniveau des Mitglieds",
  "指定等级": "Festgelegtes Niveau",
  "购买次数": "Einkaufshäufigkeit",
  "限购":  "Kaufbeschränkung",
  "每人限购": "Kaufbeschränkung pro Person",
  "次": "Mal",
  "发放设置": "Verteilungseinstellungen",
  "请输入发放数量": "Bitte geben Sie die Verteilungsmenge ein",
  "返回": "Zurück",
  "请勿重复添加": "Bitte fügen Sie nicht doppelt hinzu",
  "至少选择一个优惠券": "Bitte wählen Sie mindestens einen Gutschein aus",
  "新增活动": "Neue Aktivität hinzufügen",
  "券包设置": "Gutscheinpaketeinstellungen",
  "下载推广码": "Promotionscode herunterladen",
  "下载类型": "Download-Typ",
  "使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致": "Bevor Sie diese Funktion verwenden, gehen Sie bitte zum Backend der Mini-Programm-Plattform und stellen Sie unter ?Einstellungen“ - ?Schnittstelleneinstellungen“ - ?Folgekomponente für öffentliche Konten“ das anzuzeigende öffentliche Konto ein. Hinweis: Das konfigurierte öffentliche Konto muss mit der Mini-Programm-Entität übereinstimmen",
  "去配置": "Zur Konfiguration gehen",
  "若没有配置公众号，功能将不生效": "Wenn kein öffentliches Konto konfiguriert ist, wird die Funktion nicht wirksam",
  "在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力": "Während des Lebenszyklus eines Mini-Programms kann nur der Einstieg in das Mini-Programm aus den folgenden Szenarien die Fähigkeit zur Darstellung und Anleitung der Benutzer zum Abonnieren des öffentlichen Kontos aktivieren",
  "当小程序从扫小程序码打开时": "Wenn das Mini-Programm durch Scannen des Mini-Programmcodes geöffnet wird",
  "当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态": "Wenn das Mini-Programm von einem anderen Mini-Programm aus in das Mini-Programm zurückkehrt und das vorherige Mini-Programm nicht zerstört wurde, behält das Komponente den Zustand beim letzten öffnen des Mini-Programms bei",
  "公众号关注": "Abonnement für öffentliche Konten",
  "新客设置": "Einstellungen für Neukunden",
  "是否开启活动": "Ist die Aktivität aktiviert?",
  "活动时间": "Aktivitätszeitraum",
  "背景图": "Hintergrundbild",
  "赠送优惠券": "Gutschein verschenken",
  "请选择优惠券": "Bitte wählen Sie einen Gutschein aus",
  "赠送积分": "Punkte schenken",
  "请输入赠送积分": "Bitte geben Sie die zu verschenkenden Punkte ein",
  "直播同步": "Synchronisierung von Live-übertragungen",
  "同步直播": "Live-übertragung synchronisieren",
  "请输入直播间名称/主播昵称": "Bitte geben Sie den Namen des Live-Raums/den Spitznamen des Moderators ein",
  "直播间ID": "Live-Raum ID",
  "直播间名称": "Live-Raum Name",
  "主播昵称": "Moderator Spitzname",
  "直播开始时间": "Live-Startzeit",
  "直播结束时间": "Live-Endzeit",
  "直播间状态": "Live-Raum Status",
  "置顶": "Oben anheften",
  "未置顶": "Nicht angeheftet",
  "已置顶": "Angeheftet",
  "设为置顶": "Als Top festlegen",
  "取消置顶": "Anheften aufheben",
  "直播中": "Live",
  "未开始": "Nicht begonnen",
  "已结束": "Beendet",
  "禁播": "Sendedefekt",
  "暂停": "Pause",
  "异常": "Abnormal",
  "已过期": "Abgelaufen",
  "置顶成功": "Erfolgreich angeheftet",
  "邀请活动": "Einladungsaktion",
  "个人中心图片": "Bild im persönlichen Center",
  "请输入用户昵称/手机号": "Bitte geben Sie den Benutzernamen/Telefonnummer ein",
  "邀请人": "Einladende Person",
  "被邀请人": "Eingeladene Person",
  "参加时间": "Teilnahmezeit",
  "个人中心显示": "Anzeige im persönlichen Center",
  "参与记录": "Teilnahmerekorde",
  "礼品记录": "Geschenkrekorde",
  "推广二维码": "Promotions-QR-Code",
  "编辑活动会场": "Eventort bearbeiten",
  "请输入分享标题": "Bitte geben Sie den Titel fürs Teilen ein",
  "请输入分享内容": "Bitte geben Sie den Inhalt fürs Teilen ein",
  "分享内容": "Teilungsinhalt",
  "分享图": "Teilungsbild",
  "个人中心状态": "Status des persönlichen Centers",
  "邀请成功的条件": "Bedingungen für erfolgreiche Einladung",
  "邀请成为会员": "Einladen, Mitglied zu werden",
  "邀请成为会员且消费": "Einladen, Mitglied zu werden und zu konsumieren",
  "礼品设置": "Geschenkeinstellungen",
  "奖项": "Preis",
  "每邀请": "Pro Einladung",
  "人获得礼品": "Person erhält ein Geschenk",
  "添加奖励项": "Belohnungselement hinzufügen",
  "请上传背景图": "Bitte laden Sie das Hintergrundbild hoch",
  "请上传分享图": "Bitte laden Sie das Teilen-Bild hoch",
  "请添加奖项": "Bitte fügen Sie einen Preis hinzu",
  "开启首页推送": "Startseite-Push aktivieren",
  "建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗": "Es wird empfohlen, die Aktivität zu ändern; die änderung dieses Namens wird das Popup auf der Startseite des Einkaufszentrums entsprechend anpassen",
  "类型": "Typ",
  "图文": "Bildtext",
  "纯图": "Reines Bild",
  "领取优惠券": "Coupon erhalten",
  "请输入标题": "Bitte geben Sie einen Titel ein",
  "弹窗图片": "Popup-Bild",
  "图片为2M以内大小，格式限png，jpg格式": "Bildgröße sollte innerhalb von 2 MB liegen und im PNG- oder JPG-Format sein",
  "按钮文案": "Schaltflächentext",
  "简介说明": "Kurze Erklärung",
  "请输入说明": "Geben Sie bitte eine Erklärung ein",
  "点击选择你要链接的位置": "Klicken Sie, um die gewünschte Verknüpfungsposition anzugeben",
  "跳转地址": "Weiterleitungsadresse",
  "最多可以添加三张": "Bis zu drei Ergänzungen erlaubt",
  "最多添加3张优惠券": "Maximale Ergänzungsgrenze: 3 Gutscheine",
  "标题不能为空": "Titel darf nicht leer sein",
  "请选择跳转链接": "Wählen Sie die Weiterleitungsverbindung aus",
  "请选择优惠卷": "Wählen Sie den Coupon aus",
  "请上传图片": "Bitte laden Sie ein Bild hoch",
  "团购订单": "Gruppenkauf-Bestellungen",
  "团购管理": "Gruppenkauf-Verwaltung",
  "团购设置": "Gruppenkauf-Einstellungen",
  "订单设置": "Bestelleinstellungen",
  "未支付订单": "Nicht bezahlte Bestellungen",
  "请输入关闭时间": "Bitte geben Sie die Schließzeit ein",
  "团购保障": "Gruppenkauf-Schutz",
  "使用门店": "Geschäftsnutzung",
  "待付款": "Ausstehende Zahlung",
  "待使用": "Ausstehende Nutzung",
  "已退款": "Erstattet",
  "使用门店名称": "Geschäftsname für Nutzung",
  "门店联系人": "Geschäftskontakt",
  "门店电话": "Geschäftstelefonnummer",
  "团购信息": "Gruppenkauf-Informationen",
  "券码信息": "Gutscheincode-Informationen",
  "核销券码": "Gutscheincode einlösen",
  "添加团购": "Gruppenkauf hinzufügen",
  "团购名称": "Gruppenkauf-Name",
  "销售价格": "Verkaufspreis",
  "虚拟销量": "Virtueller Absatz",
  "部分": "Teilweise",
  "基础设置": "Grundeinstellungen",
  "购买须知": "Kaufanleitung",
  "团购详情": "Gruppenkauf-Details",
  "团购须知": "Gruppenkauf-Anleitungen",
  "请输入团购名称": "Bitte geben Sie den Namen des Gruppenkaufs ein",
  "到期类型": "Ablauf-Typ",
  "购买后生效": "Nach dem Kauf wirksam",
  "固定时间": "Feste Zeit",
  "有效天数": "Gültigkeitsdauer in Tagen",
  "请输入有效天数": "Bitte geben Sie die Gültigkeitsdauer in Tagen ein",
  "有效时间": "Gültige Zeit",
  "请输入有效时间": "Bitte geben Sie die gültige Zeit ein",
  "团购图片": "Gruppenkauf-Bild",
  "请上传团购图片": "Bitte laden Sie das Gruppenkauf-Bild hoch",
  "请输入划线价格": "Bitte geben Sie den durchgestrichenen Preis ein",
  "请输入销售价格": "Bitte geben Sie den Verkaufspreis ein",
  "请输入虚拟销量": "Bitte geben Sie die virtuelle Verkaufsmenge ein",
  "适用门店": "Anwendbare Geschäfte",
  "请选择门店": "Wählen Sie das Geschäft aus",
  "团购状态": "Gruppenkauf-Status",
  "每日限购数量": "Tägliches Kauflimit",
  "每个会员每日购买的最大数量，0为不限购": "Maximale Menge, die jedes Mitglied täglich kaufen kann; 0 für kein Limit",
  "商家名称": "Name des Anbieters",
  "平台": "Plattform",
  "满类型": "Kriterientyp",
  "满额": "Schwellenbetrag",
  "满件数": "Schwellenmenge",
  "满值": "Schwellenwert",
  "减类型": "Abzugstyp",
  "减金额": "Abzugsbetrag",
  "打折": "Rabatt",
  "减值": "Abzugswert",
  "编辑活动": "Aktivität bearbeiten",
  "满金额": "Gesamtbetrag",
  "请输入满值": "Bitte geben Sie den Schwellenwert ein",
  "如果是打折，填写80，表示打8折": "Bei Rabatt geben Sie 80 ein, um 20% Rabatt zu erhalten",
  "满额免配送费设置": "Kostenloser Versand ab Schwellenbetrag",
  "是否开启满额免配送费": "Aktivieren Sie den kostenlosen Versand ab Schwellenbetrag",
  "单笔订单满": "Einzelbestellung über",
  "如果开启满额免配送费，设置0为全场免配送费": "Bei Aktivierung des kostenlosen Versands ab Schwellenbetrag geben Sie 0 für den gesamten Auftrag ein",
  "入驻申请": "Einrichtungsanfrage",
  "配送订单": "Lieferbestellungen",
  "提现申请": "Auszahlungsanfrage",
  "配送设置": "Lieferungseinstellungen",
  "退出申请": "Austrittsantrag",
  "正常": "Normal",
  "押金": "Kaution",
  "累计佣金": "Kumulierte Provision",
  "可提现佣金": "Provision verfügbar zur Auszahlung",
  "已提现佣金": "Bereits ausgezahlte Provision",
  "提现明细": "Auszahlungsdetails",
  "申请条件": "Antragsbedingungen",
  "结算": "Abrechnung",
  "是否开启押金支付": "Einzahlungszahlung aktivieren",
  "是否审核": "überprüfung erforderlich",
  "需后台审核": "Benötigt Back-End-überprüfung",
  "无需审核": "Keine überprüfung erforderlich",
  "产品列表弹出层": "Produktliste Pop-up",
  "已选择该商品": "Produkt bereits ausgewählt",
  "注：如使用微信支付，则需申请微信支付企业付款到零钱功能": "Hinweis: Für WeChat Pay ist die Einrichtung von überweisungen an das Wallet einer Firma erforderlich",
  "微信提现方式": "WeChat-Auszahlungsmethode",
  "微信提现到零钱": "Auszahlung auf WeChat Wallet",
  "商家转账到零钱": "Händler überweist auf Wallet",
  "注：根据实际产品开通情况选择": "Je nach tatsächlicher Produktaktivierung auswählen",
  "最低提现额度": "Mindestauszahlungslimit",
  "佣金结算时间": "Provisionsabrechnungszeit",
  "注：当订单完成n小时后，该订单的配送佣金才会结算到配送员余额，如果设置为0小时，则订单完成时就结算": "Hinweis: Die Auslieferungsprovisionen werden n Stunden nach Abschluss des Auftrags auf das Konto des Lieferanten abgerechnet; Bei 0 erfolgt die Abrechnung sofort nach Abschluss des Auftrags",
  "请至少选择一种提现方式": "Bitte stellen Sie sicher, dass mindestens eine Auszahlungsmethode ausgewählt ist",
  "佣金结算": "Provisionsabrechnung",
  "是否结算佣金": "Soll die Provision abgerechnet werden?",
  "已结算": "Abgerechnet",
  "未结算": "Nicht abgerechnet",
  "送达状态": "Lieferstatus",
  "查看详情": "Details anzeigen",
  "该操作将使用微信支付企业付款到零钱功能，确定打款吗？": "Diese Aktion wird die WeChat Enterprise-Zahlung zur überweisung auf Ihr Guthaben verwenden. Sind Sie sicher bezüglich der Transaktion?",
  "身份证号": "Ausweisnummer",
  "待交押金": "Ausstehende Einzahlung",
  "审核方式": "überprüfungsmethode",
  "查看": "Inspektion",
  "配送员审核": "überprüfung des Lieferpersonals",
  "添加外卖商品": "Außer-Haus-Produkt hinzufügen",
  "序号": "Nummer",
  "活动折扣": "Aktionsrabatt",
  "活动库存": "Aktionsbestand",
  "添加店内商品": "Instore-Produkte hinzufügen",
  "优惠券列表": "Gutscheinliste",
  "发送优惠券": "Gutscheine senden",
  "发送对象": "Empfänger",
  "全站会员": "Alle Website-Mitglieder",
  "指定会员": "Bestimmtes Mitglied",
  "选择会员等级": "Mitgliedsstufe wählen",
  "发送的优惠券会员领取已达到限制数量，将不再发送给该会员": "Der Empfänger hat die Obergrenze für den Erhalt des spezifizierten Gutscheins erreicht und wird ihn nicht mehr erhalten",
  "发送成功": "Erfolgreich gesendet",
  "优惠券ID": "Gutschein-ID",
  "优惠券名称": "Gutscheinname",
  "优惠券类型": "Gutscheintyp",
  "最低消费金额": "Mindestausgabenbetrag",
  "优惠方式": "Rabattmethode",
  "立减": "Direktabzug",
  "打": "Rabatt",
  "领取": "Erhalten",
  "天内有效": "Gültig für Tage",
  "发放总数量": "Gesamtausgabemenge",
  "不限制": "Unbegrenzt",
  "已领取数量": "Anzahl der erhaltenen Gutscheine",
  "修改优惠券": "Gutschein bearbeiten",
  "请输入优惠券名称": "Bitte geben Sie den Namen des Gutscheins ein",
  "例如：满100减10": "Beispiel: Bei 100€ erhalten Sie 10€ Rabatt",
  "优惠券颜色": "Gutschein Farbe",
  "蓝色": "Blau",
  "红色": "Rot",
  "紫色": "Lila",
  "黄色": "Gelb",
  "满减券": "Rabattgutschein",
  "折扣券": "Rabatt-Rate Gutschein",
  "减免金额": "Abzugsbetrag",
  "请输入减免金额": "Bitte geben Sie den Abzugsbetrag ein",
  "折扂率": "Rabatt Rate",
  "请输入折扣率": "Bitte geben Sie die Rabatt Rate ein",
  "折扣率范围0-10，9.5代表9.5折，0代表不折扣": "Der Rabatt-Rate Bereich reicht von 0 bis 10. Zum Beispiel steht 9,5 für 5% Rabatt und 0 steht für keinen Rabatt",
  "请输入最低消费金额": "Bitte geben Sie den Mindestausgabenbetrag ein",
  "后生效": "Nach der Aktivierung",
  "请输入发放总数量": "Bitte geben Sie die Gesamtausgabemenge ein",
  "限制领取的优惠券数量，-1为不限制": "Begrenzen Sie die Anzahl der einlösbaren Gutscheine, -1 für keine Begrenzung",
  "是否显示在领券中心": "Wird im Gutscheincenter angezeigt?",
  "新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次": "Dieser Popup-Hinweis wird nur einmal angezeigt, wenn ein neuer Benutzer die Mini-App zum ersten Mal Öffnet",
  "引导收藏": "Bei der Sammlung helfen",
  "编辑类型": "Bearbeitungstyp",
  "生日设置": "Geburtseinstellungen",
  "手机短信": "Handy-SMS",
  "分销商用户": "Distributor-Benutzer",
  "分销订单": "Verteilungs-Bestellungen",
  "分销海报": "Verteilungs-Poster",
  "推荐人": "Vermittler",
  "下级用户": "Untergeordnete Benutzer",
  "一级": "Stufe Eins",
  "二级": "Stufe Zwei",
  "三级": "Stufe Drei",
  "成为时间": "Beitrittsdatum",
  "下级": "Untergeordnet",
  "加入时间": "Beitrittszeit",
  "分销商条件": "Distributor-Kriterien",
  "佣金设置": "Provisions-Einstellungen",
  "自定义文字": "Benutzerdefinierter Text",
  "申请协议": "Anwendungsvereinbarung",
  "页面背景图": "Seitenhintergrundbild",
  "分销中心页面": "Verteilungszentrum-Seite",
  "页面标题": "Seitentitel",
  "分销中心": "Verteilungszentrum",
  "非分销商提示": "Hinweis für Nicht-Verteiler",
  "您还不是分销商，请先提交申请": "Sie sind noch kein Distributor, bitte reichen Sie zuerst eine Bewerbung ein",
  "申请成为分销商": "Bewerbung als Distributor",
  "立即加入": "Jetzt beitreten",
  "可提现": "Auszahlbar",
  "待提现佣金": "Auszahlbarer Provisionsbetrag",
  "待提现": "Auszahlung ausstehend",
  "已提现金额": "Gesamtbetrag bereits ausgezahlt",
  "去提现": "Jetzt auszahlen",
  "申请成为分销商页面": "Bewerbungsseite für Distributoren",
  "请填写申请信息": "Bitte füllen Sie die Bewerbungsinformationen aus",
  "分销商申请协议": "Vereinbarung für Distributorenantrag",
  "申请成为经销商": "Bewerbung als Händler",
  "审核中提示信息": "Hinweis zur überprüfung",
  "您的申请已受理，正在进行信息核验，请耐心等待。": "Ihre Bewerbung wurde akzeptiert und die Daten werden derzeit überprüft. Bitte haben Sie etwas Geduld.",
  "去商城逛逛": "Im Online-Shop einkaufen",
  "分销订单页面": "Seite mit Verteilungsbestellungen",
  "我的团队页面": "Meine Teamseite",
  "团队总人数": "Gesamtanzahl Teammitglieder",
  "一级团队": "Primäres Team",
  "二级团队": "Sekundäres Team",
  "三级团队": "Tertiäres Team",
  "提现明细页面": "Auszahlungsdetails Seite",
  "审核中": "In überprüfung",
  "申请提现页面": "Auszahlungsanforderungsseite",
  "申请提现": "Auszahlungsantrag einreichen",
  "请输入要提取的金额": "Bitte geben Sie den gewünschten Auszahlungsbetrag ein",
  "最低提现佣金": "Minimale Auszahlungskommission",
  "提交申请": "Antrag einreichen",
  "佣金结算天数": "Provisionsabrechnungstage",
  "注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算": "Hinweis: Die Provisionen aus einem abgeschlossenen Auftrag werden nach n Tagen auf das Guthaben des Distributors abgerechnet. Bei einer Einstellung von 0 Tagen erfolgt die Abrechnung sofort nach Abschluss des Auftrags",
  "成为分销商条件": "Verteilerberechtigung",
  "购买指定商品成为分销商": "Werden Sie durch den Kauf bestimmter Produkte zum Distributor",
  "购买指定商品付款后自动成为分销商，无需后台审核": "Automatische Zuordnung als Distributor nach dem Kauf spezifischer Produkte, keine Backend-überprüfung erforderlich",
  "选择商品": "Produkte auswählen",
  "成为下线条件": "Bedingungen für Untergeordnete",
  "首次点击分享链接": "Erstes Klicken auf den Freigabelink",
  "一级佣金比例": "Primärer Provisionsanteil",
  "佣金比例范围 0% - 100%": "Provisionsanteilsbereich 0% - 100%",
  "二级佣金比例": "Sekundärer Provisionsanteil",
  "三级佣金比例": "Tertiärer Provisionsanteil",
  "是否开启分销功能": "Vertriebsfunktion aktivieren",
  "分销层级": "Vertriebsebenen",
  "一级分销": "Primärer Vertrieb",
  "二级分销": "Sekundärer Vertrieb",
  "三级分销": "Tertiärer Vertrieb",
  "分销商内购": "Distributor Eigenkauf",
  "如开启，分销商自己购买商品，获得一级佣金": "Bei Aktivierung erhalten Distributoren für eigenständige Käufe Primärprovisionen.",
  "分销中心首页": "Verteilerzentrum Startseite",
  "尺寸：宽750像素 高度227像素": "Maße: Breite 750 Pixel, Höhe 227 Pixel",
  "申请成为分销商页": "Bewerbungsseite für Vertriebshändler",
  "申请提现页": "Auszahlungsanforderungsseite",
  "分销海报设置": "Vertriebsplakat Einstellungen",
  "海报背景图": "Plakathintergrundbild",
  "尺寸：宽750像素 高大于(等于)1200像素": "Maße: Breite 750 Pixel, Höhe größer oder gleich 1200 Pixel",
  "头像宽度": "Avatar Breite",
  "头像样式": "Avatar Stil",
  "正方形": "Quadratisch",
  "圆形": "Rund",
  "昵称字体大小": "Spitznamenschriftgröße",
  "昵称字体颜色": "Spitznamenschriftfarbe",
  "小程序码宽度": "Mini-Programm Code Breite",
  "小程序码样式": "Mini-Programm Code Stil",
  "分销商": "Vertreiber",
  "一级分销商": "Primärer Vertreiber",
  "用户": "Benutzer",
  "分销佣金": "Vertriebsprovision",
  "二级分销商": "Sekundärer Vertreiber",
  "三级分销商": "Tertiärer Vertreiber",
  "分销商审核": "Vertriebsprüfung",
  "积分明细": "Punkte Details",
  "变动数量": "Mengenänderungen",
  "积分名称": "Punkte Name",
  "例": "Beispiel",
  "修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称": "Nach dem ändern des Punktenamens wird der benutzerdefinierte Name auf allen Seiten im Käuferbereich angezeigt",
  "商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”": "Unternehmen verwenden benutzerdefinierte Punktenamen für Markenführung. Zum Beispiel nennt JD Punkte 'JD Beans' und Taobao nennt sie 'Treasure Coins'",
  "积分说明": "Punkteerklärung",
  "积分赠送": "Punktevergabe",
  "是否开启购物送积分": "Aktivierung von Punkten für Einkäufe",
  "积分赠送规则": "Regeln für Punktevergabe",
  "如开启则订单完成后赠送用户积分": "Wenn aktiviert, werden Punkte dem Benutzer nach Abschluss der Bestellung gutgeschrieben",
  "订单确认收货已完成": "Bestätigung der Bestellung und Erhalt abgeschlossen",
  "已完成订单超出后台设置的申请售后期限": "Abgeschlossene Bestellungen überschreiten das im Backend festgelegte Zeitlimit für Nachverkaufsanfragen",
  "积分赠送比例": "Punktevergaberate",
  "赠送比例请填写数字0~100；订单的运费不参与积分赠送": "Bitte geben Sie eine Rate zwischen 0 und 100 ein; Versandkosten sind von der Punktevergabe ausgeschlossen",
  "订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)": "Bestellbetrag (100,00€) * Punktevergaberate (100%) = Tatsächlich vergebene Punkte (100 Punkte)",
  // =====================  营销工具end   ==========

  // =====================  数据统计 start   ==========
  "销售统计": "Verkaufsstatistiken",
  "会员统计": "Mitgliederstatistiken",
  "订单概况": "Bestellübersicht",
  "商品概况": "Produktübersicht",
  "今日": "Heute",
  "累积会员数": "Gesamtmitglieder",
  "新增会员数": "Neue Mitglieder",
  "成交会员数": "Transaktionsmitglieder",
  "排行榜": "Bestenliste",
  "用户消费榜": "Benutzer-Ausgaben-Ranking",
  "积分排行榜": "Punkterangliste",
  "邀请人排行榜": "Einlader-Rangliste",
  "成交会员占比": "Transaktionsmitgliederanteil",
  "今天": "Heute",
  "最近7天": "Letzte 7 Tage",
  "最近30天": "Letzte 30 Tage",
  "最近90天": "Letzte 90 Tage",
  "最近180天": "Letzte 180 Tage",
  "最近1年": "Letztes Jahr",
  "最近2年": "Zwei Jahre zurück",
  "所有占比": "Gesamtanteil",
  "成交会员": "Transaktionsmitglieder",
  "未成交会员": "Nicht-Transaktionsmitglieder",
  "新增会员": "Neue Mitglieder",
  "最近一周": "Letzte Woche",
  "最近一个月": "Letzter Monat",
  "最近三个月": "Die letzten drei Monate",
  "选择店铺": "Geschäft auswählen",
  "查询日期": "Abfragedatum",
  "近七天": "Letzten sieben Tage",
  "近十五天": "Letzten fünfzehn Tage",
  "自定义时间": "Benutzerdefinierte Zeit",
  "日期": "Datum",
  "有效订单数": "Anzahl gültiger Bestellungen",
  "选择时间": "Zeit auswählen",
  "交易统计": "Transaktionsstatistiken",
  "订单数": "Anzahl der Bestellungen",
  "客单价": "Durchschnittlicher Bestellwert",
  "付款订单": "Bezahlte Bestellungen",
  "付款人数": "Anzahl zahlender Kunden",
  "商品统计": "Produktstatistiken",
  "在售商品": "Verfügbare Produkte",
  "件": "Artikel",
  "已付款商品": "Bezahlte Produkte",
  "销量TOP10": "Top 10 Verkäufe",
  "浏览TOP10": "Top 10 Ansichten",
  "浏览": "Ansicht",
  "排行类型": "Ranking-Typ",
  "商品总数": "Gesamtanzahl der Produkte",
  "已上架商品": "Auf-dem-Regal-Produkte",
  "已下架商品": "Abgelegte Produkte",
  "商品导出": "Produktausfuhr",
  "商品总销量": "Gesamtverkaufsmenge",
  "商品总销售额": "Gesamtverkaufswert der Produkte",
  "资产总览": "Vermögensübersicht",
  "财务对账": "Finanzielle Abstimmung",
  "交易记录": "Transaktionsaufzeichnungen",
  "店铺结算": "Shop-Abrechnung",
  "待结算金额": "Ausstehender Abrechnungsbetrag",
  "已结算金额": "Abgerechneter Betrag",
  "交易概况": "Transaktionsübersicht",
  "外卖统计": "Takeout-Statistiken",
  "店内统计": "In-Store-Statistiken",
  "订单类型": "Bestelltyp",
  "应收金额": "Fälliger Betrag",
  "实付金额": "Bezahlter Betrag",
  "账户概况": "Kontenübersicht",
  "订单编号": "Bestellnummer",
  "支付状态": "Zahlungsstatus",
  "付款方式": "Zahlungsmethode",
  "订单费用": "Bestellkosten",
  "优惠": "Rabatt",
  "商户实际收入": "Tatsächliche Umsätze des Händlers",
  "商品ID": "Produkt-ID",
  "小计": "Zwischensumme",
  "请输入提现金额": "Bitte geben Sie den Auszahlungsbetrag ein",
  "请输入打款方式": "Bitte geben Sie die Zahlungsmethode ein",
  "支付宝真实姓名": "Alipay echter Name",
  "请输入支付宝真实姓名": "Bitte geben Sie den echten Namen von Alipay ein",
  "开户行名称": "Bankname",
  "银行开户名": "Bankkontoname",
  "真实姓名": "Echter Name",
  "应付金额": "Zu zahlender Betrag",
  "实付总额": "Gesamtbetrag bezahlt",
  "商户": "Händler",
  "结算金额": "Abrechnungsbetrag",
  "店铺结算金额": "Shop-Abrechnungsbetrag",
  "操作提示": "Betriebshinweise",
  "订单结算金额 = 店铺结算总金额(含运费)": "Bestellabrechnungsbetrag = Gesamter Shop-Abrechnungsbetrag (inklusive Versandgebühr)",
  "店铺收入金额 = 店铺结算总金额 - 店铺退款金额": "Shop-Einnahmen = Gesamter Shop-Abrechnungsbetrag - Shop-Rückerstattungsbetrag",
  "订单日期": "Bestelldatum",
  "订单结算金额": "Bestellabrechnungsbetrag",
  "配送费金额": "Versandkostenbetrag",
  "商品编码": "Produktcode",
  "可用余额": "Verfügbares Guthaben",
  "提现概况": "Auszahlungsübersicht",
  "搜索": "Suche",
  "支出": "Ausgaben",
  "金额": "Betrag",
  "收支类型": "Einnahmen und Ausgaben Typ",
  "确认要退吗?": "Bestätigen Sie die Rückgabe?",
  "申请成功": "Antragsstellung erfolgreich",
  "门店总金额": "Gesamtbetrag im Geschäft",
  "累计收入": "Kumuliertes Einkommen",
  "访客数": "Anzahl der Besucher",
  "访问量": "Besuchsvolumen",
  "店铺收藏数": "Anzahl der Shop-Favoriten",
  "商品收藏数": "Anzahl der Produkt-Favoriten",
  "访问数": "Anzahl der Besuche",
  "收藏数": "Anzahl der Favoriten",
  "数": "Anzahl",
  "待支付": "Ausstehende Zahlung",
  "实际到账": "Tatsächlich erhaltenes Betrag",
  // =====================  数据统计 end   ==========

  // ==================== 设置 start ================
  "已支付订单": "Bezahlte Bestellungen",
  "分钟后自动关闭": "automatisch schließen nach Minuten",
  "订单下单未付款，n分钟后自动关闭，设置0不自动关闭": "Bestellungen aufgegeben, aber nicht bezahlt, automatisch schließen nach n Minuten, Einstellung von 0 für kein automatisches Schließen",
  "分钟后自动核销": "automatisch validieren nach Minuten",
  "如果在期间未核销，系统自动完成核销，设置0不自动核销": "Wenn nicht innerhalb des Zeitraums validiert wird, wird das System automatisch validieren, Einstellung von 0 für kein automatisches Validieren",
  "积分商城订单流程设置": "Einstellungen für den Punkte-Shop Bestellprozess",
  "已发货订单": "Versandte Bestellungen",
  "天后自动核销": "automatische Validierung nach Tagen",
  "不包括桌台订单": "ohne Tischbestellungen",
  "恭喜你，交易设置成功": "Herzlichen Glückwunsch, die Transaktionseinstellungen wurden erfolgreich angewendet",
  // ==================== 设置 end ================
  // ==================== Layout start ===========
  "当前版本": "Aktuelle Version",
  "试用版": "Testversion",
  "专业版": "Profi-Edition",
  "高级版": "Hochwertige Ausgabe",
  "至尊版": "Supreme-Edition",
  "到期日期": "Ablaufdatum",
  "永不过期": "Nie verfällt",
  "欢迎您": "Willkommen",
  "修改密码": "Passwort ändern",
  "此操作将退出登录, 是否继续?": "Diese Aktion wird Sie ausloggen. Möchten Sie fortfahren?",
  "原始密码": "Altes Passwort",
  "新密码": "Neues Passwort",
  "确认新密码": "Neues Passwort bestätigen",
  "系统公告": "Systemmeldung",
  "请至少选择一件产品商品！": "Bitte wählen Sie mindestens ein Produkt aus!",
  "超链接设置": "Hyperlink-Einstellungen",
  "图像预览": "Bildvorschau",
  "页面": "Seite",
  "当前链接": "Aktuelle Verbindung",
  "暂无": "Keine",
  "页面路径": "Seitenpfad",
  "注意一": "Hinweis Eins",
  "注意二": "Hinweis Zwei",
  "注意三": "Hinweis Drei",
  "同一个小程序链接其他小程序，最多只能链接10个，超过将不生效": "Für denselben Mini-Programm-Link zu anderen Mini-Programmen sind maximal 10 Links zulässig; das überschreiten dieser Grenze macht sie unwirksam",
  "不能填写自身小程序appid": "Es darf nicht die App-ID des aktuellen Mini-Programms ausgefüllt werden",
  "小程序链接留空默认跳到小程序首页": "Ein leerer Mini-Programm-Link führt standardmäßig zur Startseite des Mini-Programms",
  "分类": "Kategorie",
  "选择": "Auswählen",
  "签到": "Anmelden",
  "积分商城": "Punkte-Mall",
  "秒杀": "Blitzverkauf",
  "拼团": "Gruppenkauf",
  "砍价": "Feilschen",
  "领券中心": "Coupon-Center",
  "生日有礼": "Geburtstagsgeschenk",
  "链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转": "Die verknüpfte Webseite muss SSL unterstützen und mit https:// beginnen, da sonst keine Weiterleitung möglich ist",
  "链接的域名必须是备案域名，否则无法跳转": "Die verlinkte Domain muss eine registrierte Domain sein, da sonst keine Weiterleitung möglich ist",
  "您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？": "Ihre Website-Domäne muss zur Geschäftsdomäne der WeChat Mini-Programm-Plattform hinzugefügt werden. Können Sie weitere Details angeben?",
  "选择文章列表": "Artikelliste auswählen",
  "文章标题": "Artikeltitel",
  "文章分类": "Artikelkategorie",
  "选择规格": "Spezifikationen auswählen",
  "产品/规格": "Produkt/Specifikationen",
  "已选": "Ausgewählt",
  "查看物流": "Logistik anzeigen",
  "请输入收货人": "Bitte geben Sie den Empfänger ein",
  "请输入收获电话": "Bitte geben Sie die Telefonnummer des Empfängers ein",
  "省": "Provinz",
  "市": "Stadt",
  "区": "Bezirk",
  "现金收款": "Barzahlung",
  "余额收款": "Saldozahlung",
  "其他方式": "Andere Methoden",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Bitte geben Sie die Mitglieds-ID ein, um das Mitglied zu suchen, und klicken Sie dann auf Bestätigen, wenn Sie fertig sind",
  "请输入会员ID": "Bitte geben Sie die Mitglieds-ID ein",
  "会员昵称": "Mitgliedsname",
  "余额总计": "Gesamtsaldo",
  "登录会员仅作为积分累计，无法享受其他优惠": "Angemeldete Mitglieder können nur Punkte sammeln und keine anderen Rabatte erhalten",
  "取消收款": "Zahlung abbrechen",
  "收款": "Zahlung erhalten",
  "请输入会员手机号": "Bitte geben Sie die Telefonnummer des Mitglieds ein",
  "该用户不存在": "Dieser Benutzer existiert nicht",
  "注册": "Registrieren",
  "平台名称": "Plattformname",
  "请输入平台名称": "Bitte geben Sie den Plattformnamen ein",
  "所在地区": "Standort",
  "请选择所在地区": "Bitte wählen Sie den Standort aus",
  "平台账户名": "Plattform-Kontoname",
  "请输入平台账户名": "Bitte geben Sie den Plattform-Kontonamen ein",
  "平台账户密码": "Plattform-Kontopasswort",
  "是否连锁": "Ist es eine Filiale?",
  "是": "Ja",
  "否": "Nein",
  "请输入您的地址": "Bitte geben Sie Ihre Adresse ein",
  "请输入您的联系电话": "Bitte geben Sie Ihre Kontakttelefonnummer ein",
  "请输入您的联系邮箱": "Bitte geben Sie Ihre Kontakt-E-Mail-Adresse ein",
  "联系邮箱": "Kontakt-E-Mail",
  "不能全是空格": "Darf nicht nur aus Leerzeichen bestehen",
  "不能包含空格": "Darf keine Leerzeichen enthalten",
  "长度不能小于6位": "Lönge darf nicht weniger als 6 Zeichen betragen",
  "请填写确认密码": "Bitte geben Sie das Bestätigungspasswort ein",
  "确认密码不一致": "Passwörter stimmen nicht überein",
  "联系电话和联系邮箱至少填写一个": "Bitte geben Sie mindestens eine Kontakttelefonnummer oder -E-Mail-Adresse an",
  "注册成功,请前往登录": "Registrierung erfolgreich, bitte loggen Sie sich ein",
  "清空": "Leeren",
  "确认": "Bestätigen",
  "限时免费": "Zeitlich begrenzt kostenlos",
  // ==================== Components end     =========

  // ==================== 其它  start  ================
  "菜品总量": "Gerichtsanzahl",
  "菜品排行榜": "Gerichts-Ranking",
  "商家信息": "Geschäftsinformationen",
  "与店内营业时间相同": "Gemäß den Ladenöffnungszeiten",
  "菜品": "Kulinarik",
  "菜品分类": "Speisekategorien",
  "添加菜品": "Gericht einfügen",
  "通告": "Bekanntmachung",
  "商家店名": "Geschäftsbezeichnung",
  "请输入商家店名": "Bitte tragen Sie den Geschäftsnamen ein",
  "温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱": "Hinweis: Bitte vermeiden Sie es, nach der Auswahl willkürlich zu ändern, um Datenfehler bei den Ladenspeisen zu vermeiden",
  "网址后缀设置": "URL-Suffix-Einstellung",
  "选填，设置后缀可替换下列网址末尾的数字id，方便记忆": "Optional, das Hinzufügen eines Suffixes ermöglicht es, die ID am Ende der folgenden URLs zu ersetzen, um sie leichter zu merken",
  "网址设置": "URL-Einstellungen",
  "手机网站二维码": "QR-Code für mobile Website",
  "按菜品收费": "Gebühren je Gericht",
  "外卖菜品": "Liefergerichte",
  "店内菜品": "Lokale Gerichte",
  "菜品管理": "Gerichtsverwaltung",
  "菜品名称": "Bezeichnung des Gerichts",
  "请输入菜品名称": "Bitte geben Sie die Bezeichnung des Gerichts ein",
  "此菜品正在参加活动，不能修改规格": "Dieses Gericht nimmt an einer Aktion teil, daher können die Spezifikationen nicht geändert werden",
  "通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。": "Durch den Einsatz von KI-Technologie können detaillierte Informationen wie Zutaten, Highlights und Geschmack automatisch anhand des Gerichtenamens ausgefüllt werden.",
  "请填写菜品详情": "Wir bitten um Ausfüllung der Details des Gerichts",
  "菜品详情": "Details zu Gerichten",
  "菜品图片": "Bild des Gerichts",
  "请上传菜品图片": "Bitte laden Sie ein Bild des Gerichts hoch",
  "AI未识别到您的菜品图片": "Die KI konnte Ihr Gerichtsbild nicht erkennen",
  "本菜品正在参加活动，不能删除规格！": "Dieses Gericht nimmt an einer Aktion teil, daher dürfen die Spezifikationen nicht gelöscht werden!",
  "菜品加料": "Zutaten für das Gericht",
  "菜品状态": "Status des Gerichts",
  "选择菜品状态": "Wählen Sie den Status des Gerichts",
  "菜品排序": "Sortierung der Gerichte",
  "请填写菜品名称": "Bitte geben Sie die Bezeichnung des Gerichts ein",
  "你选择菜品分类": "Sie haben die Gerichtskategorie ausgewählt",
  "菜品卖点": "Besonderheiten des Gerichts",
  "菜品属性": "Merkmale des Gerichts",
  "菜品同步": "Synchronisation der Gerichte",
  "是否同步菜品至外卖": "Sollen die Gerichte für die Lieferung synchronisiert werden?",
  "是否同步菜品至店内": "Sollen die Gerichte für den Verkauf im Lokal synchronisiert werden?",
  "搜索菜品": "Suche nach Gerichten",
  "菜品原价": "Ursprünglicher Preis des Gerichts",
  "菜品来源": "Quelle des Gerichts",
  "菜品列表": "Liste der Gerichte",
  "菜品价格": "Preis des Gerichts",
  "菜品销量": "Verkaufszahlen des Gerichts",
  "通告管理": "Verwaltung von Ankündigungen",
  "添加通告": "Ankündigung hinzufügen",
  "通告ID": "ID der Ankündigung",
  "通告标题": "Titel der Ankündigung",
  "通告分类": "Kategorie der Ankündigung",
  "通告排序": "Sortierung der Ankündigung",
  "通告状态": "Status der Ankündigung",
  "通告内容": "Inhalt der Ankündigung",
  "编辑通告": "Ankündigung bearbeiten",
  "属性名": "Attributname",
  "请输入属性名称": "Bitte geben Sie den Attributnamen ein",
  "请输入属性值": "Bitte geben Sie den Attributwert ein",
  "添加属性名": "Attributname hinzufügen",
  "AI助理形象选择": "Auswahl des Bildes des KI-Assistenten",
  "菜品信息": "Informationen zu Gerichten",
  "菜品总价": "Gesamtpreis für Gerichte",
  "请按实际店名填写，将显示在商家点餐网站上": "Bitte tragen Sie den tatsächlichen Geschäftsnamen ein, der auf der Website des Geschäfts für Bestellungen angezeigt wird",
  "首次添加桌位请先添加桌位类型": "Bitte fügen Sie zuerst den Tischtyp hinzu, wenn Sie zum ersten Mal Tische hinzufügen",
  "首次添加桌位请先添加区域": "Bitte fügen Sie zuerst den Bereich hinzu, wenn Sie zum ersten Mal Tische hinzufügen",
  "设置店内区域，如A区、B区、大厅、包厢等": "Richten Sie die Lokalbereiche ein, z.B. Bereich A, Bereich B, Lobby, Privatraum, usw.",
  "设置桌位类型，如二人桌、四人桌、大桌、小桌等": "Richten Sie die Tischtypen ein, z.B. Zweiertisch, Vierertisch, großer Tisch, kleiner Tisch, usw.",
  "该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）": "Dieses Konto wird für den Zugang zur Kasse-Website verwendet (die Kassen-URL finden Sie auf der Seite „URL-Einstellungen“)",
  "该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）": "Dieses Konto wird für den Zugang zur Küchen-Website verwendet (die Küchen-URL finden Sie auf der Seite „URL-Einstellungen“)",
  "如无需设置税率可不填写": "Wenn keine Steuersätze angegeben werden müssen, können Sie dies freilassen",
  "打款信息": "Zahlungsinformationen",
  "开户行": "Bank",
  "菜品分组": "Gerichtsgruppierung",
  "自定义名称，仅用于商家自己区分分类，不会展示给顾客": "Individueller Name, nur zur internen Unterscheidung der Kategorien durch das Geschäft, nicht sichtbar für Kunden",
  "手机网站编辑": "Mobile Website bearbeiten",
  "恢复初始默认页面": "Zurücksetzen auf Standardseite",
  "通告为手机网站上展示的通知、公告、商家介绍等， “显示”状态时，该篇通告将展示在手机网站上": "Die Ankündigungen werden auf der mobilen Website für Benachrichtigungen, Ankündigungen, Geschäftsinformationen usw. angezeigt. Im „Anzeigen“-Modus wird die jeweilige Ankündigung auf der mobilen Website angezeigt",
  "会员管理": "Mitgliederverwaltung",
  "等级管理": "Rankingverwaltung",
  "余额明细": "Kontostanddetails",
  "请输入昵称": "Bitte geben Sie Ihren Spitznamen ein",
  "邮箱": "E-Mail",
  "请输入邮箱地址": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "无等级": "Kein Level",
  "余额": "Kontostand",
  "积分": "Punkte",
  "生日": "Geburtstag",
  "充值": "Aufladen",
  "恭喜你，用户删除成功": "Herzlichen Glückwunsch, Benutzer erfolgreich gelöscht",
  "请选择等级": "Bitte wählen Sie ein Level aus",
  "管理员备注": "Admin-Bemerkungen",
  "请输入管理员备注": "Bitte geben Sie die Admin-Bemerkungen ein",
  "恭喜你，用户修改成功": "Herzlichen Glückwunsch, Benutzer erfolgreich geändert",
  "会员充值": "Mitglieder aufladen",
  "充值余额": "Kontostand aufladen",
  "当前余额": "Aktueller Kontostand",
  "充值方式": "Auflademethode",
  "增加": "Hinzufügen",
  "减少": "Verringern",
  "最终金额": "Endbetrag",
  "变更金额": "Betrag ändern",
  "请输入变更金额": "Bitte geben Sie den zu ändernden Betrag ein",
  "添加等级": "Level hinzufügen",
  "等级名称": "Level-Name",
  "权重": "Gewichtung",
  "升级条件": "Aufstiegskriterien",
  "等级权重": "Level-Gewichtung",
  "请输入等级权重": "Bitte geben Sie die Level-Gewichtung ein",
  "权重越大，等级越高": "Je höher die Gewichtung, desto höher das Level",
  "等级折扣": "Level-Rabatt",
  "请输入等级折扣": "Bitte geben Sie den Level-Rabatt ein",
  "满足以下勾选的其中一个条件，会员自动升级到该等级": "Wenn eine der unten angekreuzten Bedingungen erfüllt ist, wird das Mitglied automatisch auf dieses Level hochgestuft",
  "累计消费满": "Kumulierter Umsatz erreicht",
  "编辑等级": "Level bearbeiten",
  "累计积分满": "Kumulierte Punkte erreicht",
  "推荐人数满": "Empfohlene Anzahl erreicht",
  "恭喜你，等级修改成功": "Herzlichen Glückwunsch, Level erfolgreich geändert",
  "个": "Stücke",
  "充值设置": "Aufladungseinstellungen",
  "是否开启余额充值": "Soll die Kontostandaufladung aktiviert werden?",
  "注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启": "Hinweis: Wenn aktiviert, wird auf mobilen Geräten eine Auflade-Schaltfläche angezeigt. Wenn die App nicht eingereicht werden kann, muss dies nicht aktiviert werden",
  "是否开启自定义金额": "Soll die benutzerdefinierte Beträge aktiviert werden?",
  "注：如开启则用户可以填写充值金额": "Hinweis: Wenn aktiviert, können Benutzer den Aufladebetrag selbst eingeben",
  "最低充值金额": "Mindestaufladebetrag",
  "注：自定义充值金额最低充值多少€": "Hinweis: Mindestbetrag für benutzerdefinierte Aufladungen",
  "充值说明": "Aufladehinweise",
  "充值套餐": "Aufladepakete",
  "支付金额": "Zahlungsbetrag",
  "到账数量": "Betrag auf dem Konto",
  "充值时间": "Aufladezeit",
  "到账金额": "Betrag auf dem Konto",
  "赠送金额": "Geschenkter Betrag",
  "菜品重量": "Gewicht des Gerichts",
  "请填写菜品重量": "Bitte geben Sie das Gewicht des Gerichts ein",
  "菜品设置": "Gerichtseinstellungen",
  "已选择该菜品": "Dieses Gericht wurde bereits ausgewählt",
  "添加外卖菜品": "Gericht für Lieferung hinzufügen",
  "添加店内菜品": "Gericht für den Lokalverkauf hinzufügen",
  "折扣率": "Rabattquote",
  "我的团队": "Mein Team",
  "购买指定菜品成为分销商": "Kauf von bestimmten Gerichten, um ein Händler zu werden",
  "购买指定菜品付款后自动成为分销商，无需后台审核": "Werden Sie automatisch Händler, nachdem Sie bestimmte Gerichte bezahlt haben, ohne dass eine Prüfung erforderlich ist",
  "选择菜品": "Gerichtsauswahl",
  "如开启，分销商自己购买菜品，获得一级佣金": "Wenn aktiviert, können Händler ihre eigenen Gerichte kaufen und erhalten eine Provision der ersten Stufe",
  "菜品概况": "Gerichtsübersicht",
  "菜品统计": "Gerichtsstatistik",
  "在售菜品": "Verfügbare Gerichte",
  "已付款菜品": "Bezahlte Gerichte",
  "菜品总数": "Gesamtanzahl an Gerichten",
  "已上架菜品": "Hochgeladene Gerichte",
  "已下架菜品": "Heruntergenommene Gerichte",
  "菜品导出": "Gerichte exportieren",
  "菜品总销量": "Gesamtverkauf der Gerichte",
  "菜品总销售额": "Gesamterlös aus dem Verkauf der Gerichte",
  "菜品ID": "Gerichts-ID",
  "菜品编码": "Gerichtscode",
  "菜品收藏数": "Anzahl der Gerichtsfavoriten",
  "物流公司": "Logistikunternehmen",
  "chatgpt设置": "ChatGPT-Einstellungen",
  "消息设置": "Nachrichteneinstellungen",
  "短信设置": "SMS-Einstellungen",
  "上传设置": "Upload-Einstellungen",
  "清理缓存": "Cache löschen",
  "网址后缀英文名称": "URL-Suffix in Englisch",
  "英文名称": "Englischer Name",
  "默认头像": "Standardprofilbild",
  "英文名称必须只包含数字和英文字母": "Der englische Name darf nur Zahlen und Buchstaben enthalten",
  "恭喜你，商城设置成功": "Herzlichen Glückwunsch, die Geschäftseinstellungen waren erfolgreich",
  "表单数据不符合规则": "Die Formulardaten entsprechen nicht den Regeln",
  "剩余额度": "Verbleibendes Guthaben",
  "余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用": "Wenn das Guthaben nicht ausreicht, können Funktionen wie der intelligente Kundendienst, die Erstellung von AI-Magie und Mehrsprachenübersetzungen nicht verwendet werden",
  "使用明细": "Nutzungsdetails",
  "消费": "Verbrauch",
  "额度": "Guthaben",
  "数据缓存": "Daten-Cache",
  "恭喜你，清理成功": "Herzlichen Glückwunsch, die Bereinigung war erfolgreich",
  "管理员列表": "Admin-Liste",
  "角色管理": "Rollenverwaltung",
  "登录日志": "Anmeldeprotokoll",
  "操作日志": "Aktionsprotokoll",
  "添加管理员": "Administrator hinzufügen",
  "管理员ID": "Admin-ID",
  "用户名": "Benutzername",
  "所属角色": "Zugehörige Rolle",
  "超级管理员": "Superadministrator",
  "所属门店": "Zugehöriges Geschäft",
  "门店状态": "Geschäftsstatus",
  "已删除": "Gelöscht",
  "未删除": "Nicht gelöscht",
  "账号状态": "Kontostatus",
  "恭喜你，该管理员删除成功": "Herzlichen Glückwunsch, der Administrator wurde erfolgreich gelöscht",
  "请输入用户名": "Bitte geben Sie den Benutzernamen ein",
  "修改管理员": "Administrator bearbeiten",
  "添加角色": "Rolle hinzufügen",
  "角色ID": "Rollen-ID",
  "角色名称": "Rollenname",
  "恭喜你，该角色删除成功": "Herzlichen Glückwunsch, die Rolle wurde erfolgreich gelöscht",
  "编辑角色": "Rolle bearbeiten",
  "请输入角色名称": "Bitte geben Sie den Rollennamen ein",
  "权限列表": "Berechtigungsliste",
  "请输入用户名和真实姓名": "Bitte geben Sie Benutzername und echten Namen ein",
  "登录状态": "Anmeldestatus",
  "全部标记为已读": "Alles als gelesen markieren",
  "公告详情": "Ankündigungsdetails",
  "全部标记为已读消息吗?": "Alle Nachrichten als gelesen markieren?",
  "操作成功!": "Operation erfolgreich!",
  "已取消操作": "Operation abgebrochen",
  "订单流程设置": "Bestellprozess-Einstellungen",
  "请至少选择一件产品菜品！": "Bitte wählen Sie mindestens ein Produkt aus!",
  "区域管理": "Regionale Management",
  "点餐管理系统": "Bestellsystem",
  "首页": "Startseite",
  "余额支付": "Guthabenzahlung",
  "线下支付(现金支付)": "Offline-Zahlung (Barzahlung)",
  "线下支付(自有微信支付)": "Offline-Zahlung (Eigenes WeChat Pay)",
  "线下支付(自有支付宝支付)": "Offline-Zahlung (Eigenes Alipay)",
  "线下支付(POS刷卡支付)": "Offline-Zahlung (POS-Kartenzahlung)",
  "进行中": "In Bearbeitung",
  "待配送": "Zu liefern",
  "配送中": "Im Lieferung",
  "待接单": "Auf Bestellung warten",
  "待取货": "Zur Abholung",
  "已配送": "Geliefert",
  "已收货": "Empfang bestätigt",
  "待收货": "Zu empfangen",
  "待取消": "Zur Annullierung",
  "会员": "Mitglied",
  "商家": "Geschäft",
  "供应商": "Lieferant",
  "分销": "Vertrieb",
  "通知": "Benachrichtigung",
  "已付款": "Bezahlt",
  "用户下单": "Bestellung durch Benutzer",
  "收银台下单": "Bestellung über Kassenbereich",
  "扫码下单": "Bestellung über QR-Code",
  "团购下单": "Gruppenbestellung",
  "商城订单": "Bestellung im Online-Shop",
  "积分商城订单": "Bestellung im Bonuspunkt-Shop",
  "余额充值订单": "Bestellung zur Guthabenaufladung",
  "购卡订单": "Bestellung für Karte",
  "券包订单": "Bestellung für Gutscheinpaket",
  "配送员押金订单": "Bestellung für Lieferantenkaution",
  "快递配送": "Versand durch Paketdienst",
  "个人中心": "Persönliches Zentrum",
  "在地图中点击确认位置，坐标自动填入":"Klicken Sie auf die Karte, um den Standort zu bestätigen, und die Koordinaten werden automatisch eingetragen.",
  "添加优惠券请前往'营销工具'—'插件中心'—'优惠券'页面":"Um einen Gutschein hinzuzufügen, gehen Sie bitte zu 'Marketing' - 'Marketing-Tools' - 'Gutschein'.",
  // ==================== 其它  end    ================
  ...deLocale
}


export default de



// WEBPACK FOOTER //
// ./src/i18n/langs/de.js